// src/components/registration/WettkampferAuswahlModal.jsx - VOLLSTÄNDIG KORRIGIERT
import React, { useState, useEffect } from 'react';
import '../../styles/WettkampferAuswahlModal.css';
import '../../components/dashboard/WettkaempferDashboard.css';

const WettkampferAuswahlModal = ({ turnier, onClose, onAnmeldungAbgeschlossen, preselectedVerein, editingWettkaempfer }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [userRole, setUserRole] = useState('');
  const [userVereinId, setUserVereinId] = useState(null);

  // Schritt 1: Verein-Auswahl (nur für Admin)
  const [vereine, setVereine] = useState([]);
  const [selectedVerein, setSelectedVerein] = useState(preselectedVerein || null);
  
  // Schritt 2: Wettkämpfer-Auswahl
  const [wettkampfer, setWettkampfer] = useState([]);
  const [selectedWettkampfer, setSelectedWettkampfer] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // Schritt 3: Divisionen-Auswahl
  const [alleDivisionen, setAlleDivisionen] = useState([]); // Alle Divisionen aus DB
  const [wettkampferDivisionen, setWettkampferDivisionen] = useState({}); // { wettkaempfer_id: { passend: [], ausgewaehlt: [] } }
  const [activeWettkampferTab, setActiveWettkampferTab] = useState(null); // Aktiver Tab in Schritt 3
  // Filter für Unterkategorien pro Typ (z.B. { formen: 'alle', kickboxen: 'alle' })
  const [categoryFilters, setCategoryFilters] = useState({});
  const [activeMainCategory, setActiveMainCategory] = useState('alle'); // Haupt-Kategorie-Filter
  const [divisionSearch, setDivisionSearch] = useState(''); // Suchfeld für Divisionen
  const [divisionSort, setDivisionSort] = useState('code'); // Sortierung: code, alter, gewicht, skill
  const [showSummary, setShowSummary] = useState(false); // Zusammenfassung anzeigen

  // Smart-Modus Disziplinen-Auswahl
  const [smartDisziplinen, setSmartDisziplinen] = useState({}); // { wettkaempfer_id: [{disziplin, level, ...}] }
  const wettkampferSearchRef = React.useRef(null);

  // Team-Modal State
  const [teamModal, setTeamModal] = useState(null); // { wettkampferId, divisionCode, divisionName, mode:'duo'|'team' }
  const [teamDaten, setTeamDaten] = useState({});   // { 'wkId__divCode': { teamName, mitglieder:[] } }

  const [favoriten, setFavoriten] = useState(() => {
    // Favoriten aus localStorage laden
    const saved = localStorage.getItem('divisionFavoriten');
    return saved ? JSON.parse(saved) : [];
  });

  // Wettkämpfer-Bearbeitung
  const [editingWettkampfer, setEditingWettkampfer] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const [savingEdit, setSavingEdit] = useState(false);
  const [editError, setEditError] = useState('');
  const [skillGroups, setSkillGroups] = useState({ kata: [], grappling: [] });

  // Bereits angemeldete Divisionen pro Wettkämpfer für dieses Turnier
  // { wettkaempfer_id: [division_code, ...] }
  const [bereitsAngemeldet, setBereitsAngemeldet] = useState({});
  const [bereitsExpanded, setBereitsExpanded] = useState({});
  const [bereitsSectionOpen, setBereitsSectionOpen] = useState(false);

  // Loading & Error States
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    initializeModal();
  }, []);

  // Wenn editingWettkaempfer gesetzt ist, direkt zu Schritt 3 springen
  useEffect(() => {
    if (editingWettkaempfer && wettkampfer.length > 0 && currentStep === 2) {
      console.log('✏️ Bearbeitungsmodus für Wettkämpfer:', editingWettkaempfer);
      setSelectedWettkampfer([editingWettkaempfer.wettkaempfer_id]);
      setCurrentStep(3);
    }
  }, [editingWettkaempfer, wettkampfer, currentStep]);

  // Divisionen laden wenn Schritt 3 erreicht und noch nicht geladen
  useEffect(() => {
    if (currentStep === 3 && alleDivisionen.length === 0 && selectedWettkampfer.length > 0 && !loading) {
      console.log('📋 Lade Divisionen für Schritt 3...');
      loadDivisionen();
    }
  }, [currentStep, alleDivisionen.length, selectedWettkampfer.length, loading]);

  // ✅ VOLLSTÄNDIG KORRIGIERTE getAuthToken FUNKTION
  const getAuthToken = () => {
    console.log('🔑 Token-Extraktion gestartet...');
    
    // Versuche beide localStorage-Keys
    const clubDataStr = localStorage.getItem('clubData');
    const adminDataStr = localStorage.getItem('adminData');
    
    console.log('📦 ClubData vorhanden:', !!clubDataStr);
    console.log('📦 AdminData vorhanden:', !!adminDataStr);
    
    if (clubDataStr) {
      try {
        const clubData = JSON.parse(clubDataStr);
        console.log('🏢 ClubData Structure:', Object.keys(clubData));
        console.log('🔑 ClubData Token verfügbar:', !!clubData.token);
        
        if (clubData.token && typeof clubData.token === 'string' && clubData.token.length > 10) {
          console.log('✅ Token aus ClubData extrahiert:', clubData.token.substring(0, 20) + '...');
          return clubData.token;
        }
      } catch (e) {
        console.error('❌ ClubData Parse Error:', e);
      }
    }
    
    if (adminDataStr) {
      try {
        const adminData = JSON.parse(adminDataStr);
        console.log('👑 AdminData Structure:', Object.keys(adminData));
        console.log('🔑 AdminData Token verfügbar:', !!adminData.token);
        
        if (adminData.token && typeof adminData.token === 'string' && adminData.token.length > 10) {
          console.log('✅ Token aus AdminData extrahiert:', adminData.token.substring(0, 20) + '...');
          return adminData.token;
        }
      } catch (e) {
        console.error('❌ AdminData Parse Error:', e);
      }
    }
    
    // ✅ FALLBACK: Versuche alte Token-Keys
    const fallbackToken = localStorage.getItem('token');
    if (fallbackToken && typeof fallbackToken === 'string' && fallbackToken.length > 10) {
      console.log('🔄 Fallback Token gefunden:', fallbackToken.substring(0, 20) + '...');
      return fallbackToken;
    }
    
    console.error('❌ Kein gültiger Token gefunden in localStorage');
    console.error('🔍 localStorage Keys:', Object.keys(localStorage));
    
    return null;
  };

  // Skill-Groups laden für Edit-Modal (nach getAuthToken definiert!)
  useEffect(() => {
    const token = getAuthToken();
    if (!token) return;
    fetch('/api/divisionen/skill-groups', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.success) setSkillGroups(d.groups); })
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ KORRIGIERTE getUserData FUNKTION
  const getUserData = () => {
    console.log('👤 User-Daten-Extraktion gestartet...');
    
    const clubDataStr = localStorage.getItem('clubData');
    const adminDataStr = localStorage.getItem('adminData');
    
    if (clubDataStr) {
      try {
        const clubData = JSON.parse(clubDataStr);
        console.log('🏢 ClubData User:', clubData.user);
        
        if (clubData.user) {
          return {
            role: clubData.user.role || 'verein',
            vereinId: clubData.user.vereins_id,
            name: clubData.user.name,
            email: clubData.user.email,
            token: clubData.token
          };
        }
      } catch (e) {
        console.error('❌ ClubData User Parse Error:', e);
      }
    }
    
    if (adminDataStr) {
      try {
        const adminData = JSON.parse(adminDataStr);
        console.log('👑 AdminData User:', adminData.user);
        
        if (adminData.user) {
          return {
            role: 'admin',
            vereinId: null,
            name: adminData.user.name || 'Administrator',
            email: adminData.user.email,
            token: adminData.token
          };
        }
      } catch (e) {
        console.error('❌ AdminData User Parse Error:', e);
      }
    }
    
    console.error('❌ Keine gültigen User-Daten gefunden');
    return null;
  };

  const initializeModal = async () => {
    try {
      // ✅ KORRIGIERTE User-Daten-Extraktion
      const userData = getUserData();

      if (!userData) {
        throw new Error('Nicht angemeldet. Bitte loggen Sie sich ein.');
      }

      const { role, vereinId, name, token } = userData;

      if (!token) {
        throw new Error('Kein Authentifizierungstoken gefunden. Bitte loggen Sie sich erneut ein.');
      }

      setUserRole(role);
      setUserVereinId(vereinId);

      console.log('🔑 User-Daten initialisiert:', { role, vereinId, name, preselectedVerein });

      // Wenn ein Verein vorausgewählt wurde (z.B. von VereinDetailPage), direkt zu Schritt 2
      if (preselectedVerein && preselectedVerein.vereins_id) {
        console.log('✅ Vorausgewählter Verein:', preselectedVerein);
        setSelectedVerein(preselectedVerein);
        setCurrentStep(2);
        await loadWettkampfer(preselectedVerein.vereins_id);
        return;
      }

      if (role === 'admin') {
        // Admin: Zeige Verein-Auswahl
        setCurrentStep(1);
        await loadVereine();
      } else {
        // Verein: Lade direkt Wettkämpfer
        if (!vereinId) {
          throw new Error('Verein-ID nicht gefunden. Bitte loggen Sie sich erneut ein.');
        }

        setSelectedVerein({
          vereins_id: vereinId,
          name: name || 'Mein Verein'
        });
        setCurrentStep(2);
        await loadWettkampfer(vereinId);
      }

    } catch (err) {
      console.error('❌ Initialisierung fehlgeschlagen:', err);
      setError(err.message);
    }
  };

  // ✅ KORRIGIERTE loadVereine FUNKTION
  const loadVereine = async () => {
    setLoading(true);
    try {
      const token = getAuthToken();
      
      if (!token) {
        throw new Error('Kein Authentifizierungstoken gefunden');
      }
      
      console.log('🌐 Lade Vereine...');
      
      const response = await fetch(`/api/vereine`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Vereine Response Status:', response.status);

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Session abgelaufen. Bitte loggen Sie sich erneut ein.');
        }
        throw new Error(`Fehler beim Laden der Vereine: ${response.status}`);
      }

      const data = await response.json();
      console.log('📊 Vereine-Daten:', data);
      
      let vereineData = [];
      
      if (data.success && Array.isArray(data.data)) {
        vereineData = data.data;
      } else if (Array.isArray(data)) {
        vereineData = data;
      }

      // Nur aktive Vereine anzeigen
      const aktiveVereine = vereineData.filter(v => v.rolle === 'verein' || !v.rolle);
      setVereine(aktiveVereine);
      
      console.log('✅ Vereine geladen:', aktiveVereine.length);
    } catch (err) {
      console.error('❌ Fehler beim Laden der Vereine:', err);
      setError('Fehler beim Laden der Vereine: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ VOLLSTÄNDIG KORRIGIERTE loadWettkampfer FUNKTION - CORS-PROBLEM BEHOBEN
  const loadWettkampfer = async (vereinId) => {
    console.log('🔄 loadWettkampfer gestartet für Verein:', vereinId);
    setLoading(true);
    setError(''); // Clear previous errors
    
    try {
      const token = getAuthToken();
      
      if (!token) {
        throw new Error('Kein Authentifizierungstoken gefunden. Bitte loggen Sie sich erneut ein.');
      }
      
      console.log('✅ Token verfügbar für Wettkämpfer-API');
      console.log('👤 User-Role:', userRole);
      console.log('🏢 User-Vereins-ID:', userVereinId);
      
      const url = `/api/wettkaempfer/verein/${vereinId}`;
      console.log('🌐 API-URL:', url);
      
      // ✅ KORRIGIERT: Minimale Headers - KEIN cache-control!
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };
      
      console.log('📤 Request Headers:', headers);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: headers
        // ✅ ENTFERNT: cache, X-Requested-With, Cache-Control
      });
      
      console.log('📡 Wettkämpfer Response Status:', response.status);
      console.log('📡 Response Headers:', Object.fromEntries(response.headers.entries()));
      
      if (!response.ok) {
        let errorMessage = `HTTP ${response.status}`;
        
        try {
          const errorText = await response.text();
          console.error('❌ API Error Response:', errorText);
          
          if (response.status === 401) {
            // Auth-Fehler: Token abgelaufen oder ungültig
            errorMessage = 'Authentifizierungsfehler. Bitte schließen Sie das Modal und versuchen Sie es erneut.';
          } else if (response.status === 403) {
            errorMessage = 'Zugriff verweigert. Sie haben keine Berechtigung für diese Wettkämpfer.';
          } else if (response.status === 400) {
            errorMessage = `Ungültige Anfrage: ${errorText}`;
          } else if (response.status === 500) {
            errorMessage = 'Server-Fehler. Bitte versuchen Sie es später erneut.';
          } else if (response.status === 0) {
            errorMessage = 'Netzwerk-Fehler. Prüfen Sie Ihre Internetverbindung.';
          }
        } catch (e) {
          console.error('❌ Error parsing response:', e);
          errorMessage = 'Unbekannter Server-Fehler aufgetreten.';
        }
        
        throw new Error(errorMessage);
      }
      
      const data = await response.json();
      console.log('📊 Wettkämpfer-Daten empfangen:', data);
      
      let wettkampferData = [];
      
      if (data.success && Array.isArray(data.data)) {
        wettkampferData = data.data;
      } else if (Array.isArray(data)) {
        wettkampferData = data;
      } else {
        console.warn('⚠️ Unerwartetes Datenformat:', data);
        throw new Error('Unerwartetes Datenformat vom Server erhalten.');
      }

      setWettkampfer(wettkampferData);
      console.log(`✅ ${wettkampferData.length} Wettkämpfer erfolgreich geladen`);

      if (wettkampferData.length === 0) {
        console.log('ℹ️ Keine Wettkämpfer für Verein', vereinId, 'gefunden');
        setError(`Keine Wettkämpfer für diesen Verein gefunden.`);
      }

      // Bereits angemeldete Divisionen für dieses Turnier laden
      try {
        const anmRes = await fetch(`/api/anmeldungen/verein/${vereinId}`, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        if (anmRes.ok) {
          const anmData = await anmRes.json();
          const anmeldungen = anmData.data?.anmeldungen || [];
          // Nur Anmeldungen für dieses Turnier, mit aktivem Status
          const map = {};
          anmeldungen
            .filter(a => a.turnier_id === turnier.turnier_id && a.status !== 'Storniert' && a.division_code)
            .forEach(a => {
              const wkId = a.wettkaempfer_id;
              if (!map[wkId]) map[wkId] = [];
              if (!map[wkId].includes(a.division_code)) map[wkId].push(a.division_code);
            });
          setBereitsAngemeldet(map);
        }
      } catch { /* Fehler beim Laden der Anmeldungen sind nicht kritisch */ }

    } catch (err) {
      console.error('❌ Fehler beim Laden der Wettkämpfer:', err);
      
      // ✅ SPEZIELLE CORS-FEHLER-BEHANDLUNG
      if (err.message.includes('Failed to fetch') || err.name === 'TypeError') {
        console.error('🌐 CORS oder Netzwerk-Fehler erkannt');
        setError('Verbindungsfehler zum Server. Bitte prüfen Sie:\n• Ist das Backend gestartet?\n• CORS-Konfiguration korrekt?\n• Internetverbindung verfügbar?');
      } else {
        setError('Fehler beim Laden der Wettkämpfer: ' + err.message);
      }
      
      setWettkampfer([]);
      
      // ✅ ZUSÄTZLICHE ERROR-LOGGING
      console.error('📍 Error Details:', {
        message: err.message,
        name: err.name,
        stack: err.stack,
        vereinId: vereinId,
        userRole: userRole,
        userVereinId: userVereinId,
        timestamp: new Date().toISOString(),
        url: `/api/wettkaempfer/verein/${vereinId}`
      });
      
    } finally {
      setLoading(false);
    }
  };

  const handleVereinSelect = async (verein) => {
    console.log('🏢 Verein ausgewählt:', verein);
    setSelectedVerein(verein);
    setCurrentStep(2);
    await loadWettkampfer(verein.vereins_id);
  };

  const handleWettkampferToggle = (wettkampferId) => {
    setSelectedWettkampfer(prev => {
      if (prev.includes(wettkampferId)) {
        return prev.filter(id => id !== wettkampferId);
      } else {
        return [...prev, wettkampferId];
      }
    });
    setSearchTerm('');
    wettkampferSearchRef.current?.focus();
  };

  const removeWettkampferFromStep3 = (wettkampferId) => {
    setSelectedWettkampfer(prev => prev.filter(id => id !== wettkampferId));
    setWettkampferDivisionen(prev => { const n = { ...prev }; delete n[wettkampferId]; return n; });
    setSmartDisziplinen(prev => { const n = { ...prev }; delete n[wettkampferId]; return n; });
    setActiveWettkampferTab(prev => prev === wettkampferId ? null : prev);
  };

  // ── Divisionen für einen einzelnen Athleten aus alleDivisionen berechnen ──
  const computeAndSetAthleteDivisionen = (wId, divisionenSrc) => {
    const src = divisionenSrc || alleDivisionen;
    const w = wettkampfer.find(wk => wk.wettkaempfer_id === wId);
    if (!w || !src.length) return;

    const skillLevelMapping = {
      'beginner': ['Beginner', 'Amateur', 'Rookie Grappling'],
      'intermediate': ['Intermediate', 'Amateur', 'Advanced Grappling'],
      'advanced': ['Advanced', 'Amateur', 'Master Grappling'],
      'black belt': ['Black Belts', 'Advanced', 'Master Grappling', 'Grand Champion']
    };
    const skillLevelMappingFormen = {
      'beginner': ['Beginner', 'Intermediate', 'Amateur', 'Rookie Grappling', 'Breaking'],
      'intermediate': ['Intermediate', 'Advanced', 'Amateur', 'Advanced Grappling', 'Breaking'],
      'advanced': ['Advanced', 'Black Belts', 'Amateur', 'Master Grappling', 'Breaking'],
      'black belt': ['Black Belts', 'Advanced', 'Master Grappling', 'Grand Champion', 'Breaking']
    };
    const formenTypes = ['Formen', 'Selbstverteidigung', 'Forms', 'Self Defense', 'Breaking', 'Bruchtest'];
    const kampfTypes = ['Kumite', 'Sparring', 'Fighting', 'Combat', 'Grappling', 'Kickboxen', 'Kickboxing', 'Pointfighting', 'Continous Fighting', 'Continuous Fighting', 'Fullcontact', 'Full Contact', 'K1', 'K-1', 'Rumble'];

    const alter = calculateAge(w.geburtsdatum);
    const gewicht = parseFloat(w.gewicht) || 0;
    const geschlecht = w.geschlecht?.toLowerCase();
    const skillLevelKata = (w.skill_level_kata || w.skill_level)?.toLowerCase();
    const skillLevelGrappling = (w.skill_level_grappling || w.skill_level)?.toLowerCase();
    const skillLevel = w.skill_level?.toLowerCase();

    const passendeDivisionen = src.filter(div => {
      const divType = div.Division_Type || '';
      const isFormen = formenTypes.some(t => divType.toLowerCase().includes(t.toLowerCase()));
      const isKampf  = kampfTypes.some(t => divType.toLowerCase().includes(t.toLowerCase()));
      const ageFrom = parseInt(div.Age_from), ageTo = parseInt(div.Age_to);
      if (!isNaN(ageFrom) && !isNaN(ageTo)) {
        if (isKampf) {
          if (!(alter >= ageFrom && alter <= ageTo) && !(alter < ageFrom && alter >= (ageFrom - 5))) return false;
        } else { if (alter < ageFrom || alter > ageTo) return false; }
      }
      const minW = parseFloat(div.Minimun_Weight), maxW = parseFloat(div.Maximum_Weight);
      if (gewicht > 0 && !isNaN(minW) && !isNaN(maxW)) {
        if (isKampf) {
          if (!(gewicht >= minW && gewicht <= maxW) && !(gewicht < minW && gewicht >= (minW - 10))) return false;
        } else { if (gewicht < minW || gewicht > maxW) return false; }
      }
      const relSkill = isFormen ? skillLevelKata : (isKampf ? skillLevelGrappling : skillLevel);
      if (div.Skill_Level && relSkill) {
        const erlaubt = isFormen ? (skillLevelMappingFormen[relSkill] || []) : (skillLevelMapping[relSkill] || []);
        if (erlaubt.length > 0 && !erlaubt.includes(div.Skill_Level)) return false;
      }
      if (div.Gender && geschlecht) {
        const dg = div.Gender.toLowerCase();
        if (dg !== 'mixed' && dg !== 'm/f' && dg !== 'all' && dg !== 'male/female' && dg !== 'männlich/weiblich' && dg !== '') {
          const isMale = geschlecht === 'männlich' || geschlecht === 'm' || geschlecht === 'male';
          const isFemale = geschlecht === 'weiblich' || geschlecht === 'f' || geschlecht === 'female';
          const divIsMale = dg === 'm' || dg === 'male' || dg === 'männlich';
          const divIsFemale = dg === 'f' || dg === 'female' || dg === 'weiblich';
          if (divIsMale && isFemale) return false;
          if (divIsFemale && isMale) return false;
        }
      }
      return true;
    });

    let vorausgewaehlt = [];
    if (editingWettkaempfer?.wettkaempfer_id === wId && editingWettkaempfer?.existingDivisions) {
      vorausgewaehlt = editingWettkaempfer.existingDivisions.filter(c => passendeDivisionen.some(d => d.Division_Code === c));
    } else if (bereitsAngemeldet[wId]?.length) {
      vorausgewaehlt = bereitsAngemeldet[wId].filter(c => passendeDivisionen.some(d => d.Division_Code === c));
    }

    setWettkampferDivisionen(prev => ({ ...prev, [wId]: { passend: passendeDivisionen, ausgewaehlt: vorausgewaehlt } }));
  };

  // ── Athlet im Panel aktivieren (Divisionen lazy laden) ──
  const activateAthlete = async (wId) => {
    setActiveWettkampferTab(wId);
    setCategoryFilters({});
    setActiveMainCategory('alle');
    if (!selectedWettkampfer.includes(wId)) {
      setSelectedWettkampfer(prev => [...prev, wId]);
    }
    if (wettkampferDivisionen[wId]) return;

    let divSrc = alleDivisionen;
    if (divSrc.length === 0) {
      // Divisionen erstmalig laden — direkt als lokale Variable, nicht über State warten
      setLoading(true);
      try {
        const token = getAuthToken();
        const response = await fetch('/api/divisionen?limit=2000', {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) divSrc = data.data;
        else if (Array.isArray(data)) divSrc = data;
        setAlleDivisionen(divSrc);
      } catch (err) {
        setError('Fehler beim Laden der Divisionen: ' + err.message);
        setLoading(false);
        return;
      }
      setLoading(false);
    }
    computeAndSetAthleteDivisionen(wId, divSrc);
  };

  const handleSelectAll = () => {
    const filteredIds = filteredWettkampfer.map(w => w.wettkaempfer_id);
    if (selectedWettkampfer.length === filteredIds.length) {
      setSelectedWettkampfer([]);
    } else {
      setSelectedWettkampfer(filteredIds);
    }
  };

  // Divisionen laden und für jeden Wettkämpfer filtern
  const loadDivisionen = async () => {
    setLoading(true);
    setError('');

    try {
      const token = getAuthToken();

      if (!token) {
        throw new Error('Kein Authentifizierungstoken gefunden');
      }

      // Lade alle Divisionen
      console.log('📋 Lade Divisionen...');
      const response = await fetch('/api/divisionen?limit=2000', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Fehler beim Laden der Divisionen: ${response.status}`);
      }

      const data = await response.json();
      console.log('📊 Divisionen geladen:', data);

      let divisionen = [];
      if (data.success && Array.isArray(data.data)) {
        divisionen = data.data;
      } else if (Array.isArray(data)) {
        divisionen = data;
      }

      setAlleDivisionen(divisionen);
      console.log(`✅ ${divisionen.length} Divisionen geladen`);

      // Skill-Level Reihenfolge und Mapping
      const skillLevelOrder = ['Beginner', 'Intermediate', 'Advanced', 'Black Belts'];

      // Basis Skill-Level Mapping (Wettkämpfer -> Divisionen)
      const skillLevelMapping = {
        'beginner': ['Beginner', 'Amateur', 'Rookie Grappling'],
        'intermediate': ['Intermediate', 'Amateur', 'Advanced Grappling'],
        'advanced': ['Advanced', 'Amateur', 'Master Grappling'],
        'black belt': ['Black Belts', 'Advanced', 'Master Grappling', 'Grand Champion']
      };

      // Erweiterte Skills für Formen/Selbstverteidigung (eine Stufe höher erlaubt)
      // "Breaking" = spezieller Bruchtest-Skill, offen für alle Levels
      const skillLevelMappingFormen = {
        'beginner': ['Beginner', 'Intermediate', 'Amateur', 'Rookie Grappling', 'Breaking'],
        'intermediate': ['Intermediate', 'Advanced', 'Amateur', 'Advanced Grappling', 'Breaking'],
        'advanced': ['Advanced', 'Black Belts', 'Amateur', 'Master Grappling', 'Breaking'],
        'black belt': ['Black Belts', 'Advanced', 'Master Grappling', 'Grand Champion', 'Breaking']
      };

      // Kategorien die Formen/Selbstverteidigung sind (Skill eine Stufe höher)
      const formenTypes = ['Formen', 'Selbstverteidigung', 'Forms', 'Self Defense', 'Breaking', 'Bruchtest'];
      // Kategorien die Kampf sind (Alter/Gewicht eine Klasse höher)
      const kampfTypes = [
        'Kumite', 'Sparring', 'Fighting', 'Combat', 'Grappling',
        'Kickboxen', 'Kickboxing', 'Pointfighting', 'Continous Fighting',
        'Continuous Fighting', 'Fullcontact', 'Full Contact', 'K1', 'K-1',
        'Rumble'
      ];

      // Für jeden ausgewählten Wettkämpfer passende Divisionen filtern
      const wettkampferDivisionenMap = {};

      selectedWettkampfer.forEach(wId => {
        const w = wettkampfer.find(wk => wk.wettkaempfer_id === wId);
        if (!w) return;

        const alter = calculateAge(w.geburtsdatum);
        const gewicht = parseFloat(w.gewicht) || 0;
        const geschlecht = w.geschlecht?.toLowerCase();
        const skillLevel = w.skill_level?.toLowerCase();
        const skillLevelKata = (w.skill_level_kata || w.skill_level)?.toLowerCase();
        const skillLevelGrappling = (w.skill_level_grappling || w.skill_level)?.toLowerCase();

        console.log(`🔍 Filtere für ${w.vorname} ${w.nachname}:`, {
          alter, gewicht, geschlecht, skillLevel, skillLevelKata, skillLevelGrappling
        });

        // Finde passende Divisionen
        const passendeDivisionen = divisionen.filter(div => {
          const divType = div.Division_Type || '';
          const isFormen = formenTypes.some(t => divType.toLowerCase().includes(t.toLowerCase()));
          const isKampf = kampfTypes.some(t => divType.toLowerCase().includes(t.toLowerCase()));

          // Alterscheck
          const ageFrom = parseInt(div.Age_from);
          const ageTo = parseInt(div.Age_to);

          if (!isNaN(ageFrom) && !isNaN(ageTo)) {
            if (isKampf) {
              // Kampf: Eine Altersklasse höher erlaubt
              // Wettkämpfer passt wenn sein Alter in der Klasse ist ODER
              // wenn er in der nächst-niedrigeren Klasse wäre (d.h. er ist jünger als ageFrom aber max. eine Klasse)
              const alterPasstExakt = alter >= ageFrom && alter <= ageTo;
              const alterPasstHoeher = alter < ageFrom && alter >= (ageFrom - 5); // ca. eine Altersklasse (~5 Jahre)
              if (!alterPasstExakt && !alterPasstHoeher) return false;
            } else {
              // Formen/Andere: Exakte Alterspassung
              if (alter < ageFrom || alter > ageTo) return false;
            }
          }

          // Gewichtscheck
          const minWeight = parseFloat(div.Minimun_Weight);
          const maxWeight = parseFloat(div.Maximum_Weight);

          if (gewicht > 0 && !isNaN(minWeight) && !isNaN(maxWeight)) {
            if (isKampf) {
              // Kampf: Eine Gewichtsklasse höher erlaubt
              const gewichtPasstExakt = gewicht >= minWeight && gewicht <= maxWeight;
              const gewichtPasstHoeher = gewicht < minWeight && gewicht >= (minWeight - 10); // ca. eine Gewichtsklasse (~10kg)
              if (!gewichtPasstExakt && !gewichtPasstHoeher) return false;
            } else {
              // Formen/Andere: Exakte Gewichtspassung (falls definiert)
              if (gewicht < minWeight || gewicht > maxWeight) return false;
            }
          }

          // Skill-Level Check — typ-spezifische Levels verwenden
          const relevantSkillLevel = isFormen
            ? skillLevelKata
            : (isKampf ? skillLevelGrappling : skillLevel);

          if (div.Skill_Level && relevantSkillLevel) {
            const erlaubteSkills = isFormen
              ? (skillLevelMappingFormen[relevantSkillLevel] || [])
              : (skillLevelMapping[relevantSkillLevel] || []);

            if (erlaubteSkills.length > 0 && !erlaubteSkills.includes(div.Skill_Level)) {
              return false;
            }
          }

          // Geschlechtscheck
          if (div.Gender && geschlecht) {
            const divGender = div.Gender.toLowerCase();
            if (divGender !== 'mixed' && divGender !== 'm/f' && divGender !== 'all' && divGender !== '') {
              const isMale = geschlecht === 'männlich' || geschlecht === 'm' || geschlecht === 'male';
              const isFemale = geschlecht === 'weiblich' || geschlecht === 'f' || geschlecht === 'female';
              const divIsMale = divGender === 'm' || divGender === 'male' || divGender === 'männlich';
              const divIsFemale = divGender === 'f' || divGender === 'female' || divGender === 'weiblich';

              if (divIsMale && isFemale) return false;
              if (divIsFemale && isMale) return false;
            }
          }

          return true;
        });

        console.log(`👤 ${w.vorname} ${w.nachname}: ${passendeDivisionen.length} passende Divisionen`);
        if (passendeDivisionen.length > 0) {
          console.log(`   Beispiele:`, passendeDivisionen.slice(0, 5).map(d => `${d.Division_Code} (${d.Division_Type}, ${d.Skill_Level})`));
        }

        // Bereits angemeldete Kategorien vorauswählen (Bearbeitungsmodus oder Nachmeldung)
        let vorausgewaehlteKategorien = [];
        if (editingWettkaempfer && editingWettkaempfer.wettkaempfer_id === wId && editingWettkaempfer.existingDivisions) {
          vorausgewaehlteKategorien = editingWettkaempfer.existingDivisions.filter(divCode =>
            passendeDivisionen.some(d => d.Division_Code === divCode)
          );
          console.log(`✏️ Bearbeitungsmodus: ${vorausgewaehlteKategorien.length} bereits angemeldete Kategorien vorausgewählt`);
        } else if (bereitsAngemeldet[wId]?.length) {
          vorausgewaehlteKategorien = bereitsAngemeldet[wId].filter(divCode =>
            passendeDivisionen.some(d => d.Division_Code === divCode)
          );
          console.log(`🔄 Nachmeldung: ${vorausgewaehlteKategorien.length} bestehende Divisionen vorausgewählt`);
        }

        wettkampferDivisionenMap[wId] = {
          passend: passendeDivisionen,
          ausgewaehlt: vorausgewaehlteKategorien
        };
      });

      setWettkampferDivisionen(wettkampferDivisionenMap);

      // Ersten Wettkämpfer als aktiven Tab setzen
      if (selectedWettkampfer.length > 0) {
        setActiveWettkampferTab(selectedWettkampfer[0]);
      }

    } catch (err) {
      console.error('❌ Fehler beim Laden der Divisionen:', err);
      setError('Fehler beim Laden der Divisionen: ' + err.message);
    } finally {
      setLoading(false);
    }
  };


  // Division für Wettkämpfer togglen
  // Erkennt ob eine Division Team oder Duo ist
  const getTeamMode = (divisionName) => {
    const n = (divisionName || '').toLowerCase();
    if (n.includes('duo')) return 'duo';
    if (n.includes('team')) return 'team';
    return null;
  };

  const handleDivisionToggle = (wettkampferId, divisionCode) => {
    const current = wettkampferDivisionen[wettkampferId] || { passend: [], ausgewaehlt: [] };
    const ausgewaehlt = current.ausgewaehlt || [];

    if (ausgewaehlt.includes(divisionCode)) {
      // Abwählen → Division + Teamdaten entfernen
      setWettkampferDivisionen(prev => ({
        ...prev,
        [wettkampferId]: { ...prev[wettkampferId], ausgewaehlt: ausgewaehlt.filter(c => c !== divisionCode) }
      }));
      setTeamDaten(prev => { const n = { ...prev }; delete n[`${wettkampferId}__${divisionCode}`]; return n; });
    } else {
      // Auswählen → bei Team/Duo zuerst Modal öffnen
      const division = alleDivisionen.find(d => d.Division_Code === divisionCode)
        || (wettkampferDivisionen[wettkampferId]?.passend || []).find(d => d.Division_Code === divisionCode);
      const mode = getTeamMode(division?.Division_Name);
      if (mode) {
        setTeamModal({ wettkampferId, divisionCode, divisionName: division.Division_Name, mode });
      } else {
        setWettkampferDivisionen(prev => {
          const c = prev[wettkampferId] || { passend: [], ausgewaehlt: [] };
          return { ...prev, [wettkampferId]: { ...c, ausgewaehlt: [...(c.ausgewaehlt || []), divisionCode] } };
        });
      }
    }
  };

  // Wird vom Team-Modal nach Bestätigung aufgerufen
  // fighters = Array von Fighter-Objekten (oder null wenn manuell eingetippt)
  const confirmTeamModal = (teamName, mitglieder, fighters) => {
    const { wettkampferId, divisionCode } = teamModal;
    const key = `${wettkampferId}__${divisionCode}`;

    // Teamdaten + Division für den Hauptkämpfer
    setTeamDaten(prev => ({ ...prev, [key]: { teamName, mitglieder } }));
    setWettkampferDivisionen(prev => {
      const c = prev[wettkampferId] || { passend: [], ausgewaehlt: [] };
      return { ...prev, [wettkampferId]: { ...c, ausgewaehlt: [...(c.ausgewaehlt || []), divisionCode] } };
    });

    // Partner automatisch mit-anmelden
    const mainFighter = wettkampfer.find(w => w.wettkaempfer_id === wettkampferId);
    const mainName = mainFighter ? `${mainFighter.vorname} ${mainFighter.nachname}` : '';

    (fighters || []).forEach((fighter, idx) => {
      if (!fighter) return;
      const fId = fighter.wettkaempfer_id;

      // Zum Schritt-2-Pool hinzufügen falls noch nicht drin
      setSelectedWettkampfer(prev => prev.includes(fId) ? prev : [...prev, fId]);

      // Passende Divisionen berechnen und die Team-Division vorauswählen
      const passend = computePassendeDivisionen(fighter);
      setWettkampferDivisionen(prev => {
        const c = prev[fId] || { passend, ausgewaehlt: [] };
        const ausgewaehlt = c.ausgewaehlt.includes(divisionCode)
          ? c.ausgewaehlt
          : [...c.ausgewaehlt, divisionCode];
        return { ...prev, [fId]: { passend: c.passend.length > 0 ? c.passend : passend, ausgewaehlt } };
      });

      // Reverse-TeamDaten: Partner hat Hauptkämpfer als Gegenpart
      const reverseKey = `${fId}__${divisionCode}`;
      setTeamDaten(prev => ({
        ...prev,
        [reverseKey]: { teamName, mitglieder: [mainName] }
      }));
    });

    setTeamModal(null);
  };

  // Alle Divisionen für einen Wettkämpfer auswählen/abwählen
  const handleSelectAllDivisionen = (wettkampferId) => {
    setWettkampferDivisionen(prev => {
      const current = prev[wettkampferId] || { passend: [], ausgewaehlt: [] };
      const allCodes = current.passend.map(d => d.Division_Code);

      if (current.ausgewaehlt.length === allCodes.length) {
        return { ...prev, [wettkampferId]: { ...current, ausgewaehlt: [] } };
      } else {
        return { ...prev, [wettkampferId]: { ...current, ausgewaehlt: allCodes } };
      }
    });
  };

  // Anmelden ohne Kategorie (Kategorie kann später nachgetragen werden)
  const submitOhneKategorie = async () => {
    if (selectedWettkampfer.length === 0) {
      setError('Bitte wählen Sie mindestens einen Wettkämpfer aus.');
      return;
    }
    setSubmitting(true);
    try {
      const token = getAuthToken();
      if (!token) throw new Error('Kein Authentifizierungstoken gefunden');
      const anmeldungData = {
        turnier_id: turnier.turnier_id,
        verein_id: selectedVerein.vereins_id,
        wettkampfer_ids: selectedWettkampfer,
        wettkampfer_divisionen: selectedWettkampfer.map(id => ({ wettkaempfer_id: id, divisionen: [] })),
        anmelde_datum: new Date().toISOString(),
        is_update: !!editingWettkaempfer,
      };
      const response = await fetch('/api/anmeldungen', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(anmeldungData)
      });
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || err.error || `HTTP ${response.status}`);
      }
      const result = await response.json();
      if (result.skipped?.length > 0) {
        setInfo(`ℹ️ ${result.skipped.length} Wettkämpfer bereits angemeldet — übersprungen.`);
        setTimeout(() => setInfo(''), 4000);
      }
      if (onAnmeldungAbgeschlossen) {
        onAnmeldungAbgeschlossen({ turnier, verein: selectedVerein, wettkampfer: selectedWettkampfer });
      }
      onClose();
    } catch (err) {
      setError('Anmeldung fehlgeschlagen: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  // Weiter zu Schritt 3
  const handleWeiterZuDivisionen = async () => {
    if (selectedWettkampfer.length === 0) {
      setError('Bitte wählen Sie mindestens einen Wettkämpfer aus.');
      return;
    }
    setCurrentStep(3);
    if (turnier.modus !== 'smart') {
      await loadDivisionen();
    }
  };

  // Prüfen ob alle Wettkämpfer mindestens eine Division/Disziplin haben
  const alleHabenDivisionen = () => {
    if (turnier.modus === 'smart') {
      return selectedWettkampfer.every(wId => (smartDisziplinen[wId] || []).length > 0);
    }
    return selectedWettkampfer.every(wId =>
      wettkampferDivisionen[wId] &&
      wettkampferDivisionen[wId].ausgewaehlt &&
      wettkampferDivisionen[wId].ausgewaehlt.length > 0
    );
  };

  // Favoriten toggle
  const toggleFavorit = (divisionCode) => {
    setFavoriten(prev => {
      const newFavoriten = prev.includes(divisionCode)
        ? prev.filter(c => c !== divisionCode)
        : [...prev, divisionCode];
      localStorage.setItem('divisionFavoriten', JSON.stringify(newFavoriten));
      return newFavoriten;
    });
  };

  // Sortier-Funktion für Divisionen
  const sortDivisionen = (divs) => {
    const sorted = [...divs];
    switch (divisionSort) {
      case 'alter':
        return sorted.sort((a, b) => (parseInt(a.Age_from) || 0) - (parseInt(b.Age_from) || 0));
      case 'gewicht':
        return sorted.sort((a, b) => (parseFloat(a.Minimun_Weight) || 0) - (parseFloat(b.Minimun_Weight) || 0));
      case 'skill':
        const skillOrder = { 'Beginner': 1, 'Intermediate': 2, 'Amateur': 3, 'Advanced': 4, 'Black Belts': 5 };
        return sorted.sort((a, b) => (skillOrder[a.Skill_Level] || 99) - (skillOrder[b.Skill_Level] || 99));
      case 'favoriten':
        return sorted.sort((a, b) => {
          const aFav = favoriten.includes(a.Division_Code) ? 0 : 1;
          const bFav = favoriten.includes(b.Division_Code) ? 0 : 1;
          return aFav - bFav;
        });
      default: // code
        return sorted.sort((a, b) => (a.Division_Code || '').localeCompare(b.Division_Code || ''));
    }
  };

  // Such-Filter für Divisionen
  const filterBySearch = (divs) => {
    if (!divisionSearch.trim()) return divs;
    const search = divisionSearch.toLowerCase();
    return divs.filter(d =>
      d.Division_Code?.toLowerCase().includes(search) ||
      d.Division_Name?.toLowerCase().includes(search)
    );
  };

  // Zusammenfassung aller Auswahlen
  const getZusammenfassung = () => {
    return selectedWettkampfer.map(wId => {
      const w = wettkampfer.find(wk => wk.wettkaempfer_id === wId);
      const divData = wettkampferDivisionen[wId] || { passend: [], ausgewaehlt: [] };
      const ausgewaehlte = divData.ausgewaehlt || [];
      const divisionDetails = ausgewaehlte.map(code =>
        alleDivisionen.find(d => d.Division_Code === code)
      ).filter(Boolean);

      return {
        wettkampfer: w,
        divisionen: divisionDetails
      };
    });
  };

  // Wettkämpfer bearbeiten - Modal öffnen
  const openEditModal = (w) => {
    setEditFormData({
      wettkaempfer_id: w.wettkaempfer_id,
      vereins_id: w.vereins_id || '',
      vorname: w.vorname || '',
      nachname: w.nachname || '',
      geburtsdatum: w.geburtsdatum ? w.geburtsdatum.split('T')[0] : '',
      geschlecht: w.geschlecht || 'männlich',
      gewicht: w.gewicht || '',
      gurtfarbe: w.gurtfarbe || '',
      skill_level_kata: w.skill_level_kata || w.skill_level || '',
      skill_level_grappling: w.skill_level_grappling || '',
      email: w.email || '',
      handy: w.handy || '',
      kampfstil: w.kampfstil || ''
    });
    setEditError('');
    setEditingWettkampfer(w);
  };

  // Wettkämpfer speichern
  const saveWettkampferEdit = async () => {
    setEditError('');
    setSavingEdit(true);
    try {
      const token = getAuthToken();
      if (!token) {
        throw new Error('Kein Authentifizierungstoken gefunden');
      }

      const response = await fetch(`/api/wettkaempfer/${editFormData.wettkaempfer_id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(editFormData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        const msg = errorData.details?.join(', ') || errorData.error || errorData.message || `HTTP ${response.status}`;
        throw new Error(msg);
      }

      // Aktualisiere lokalen State
      setWettkampfer(prev => prev.map(w =>
        w.wettkaempfer_id === editFormData.wettkaempfer_id
          ? { ...w, ...editFormData }
          : w
      ));

      setEditingWettkampfer(null);
      setEditFormData({});
      setEditError('');
    } catch (err) {
      console.error('❌ Fehler beim Speichern:', err);
      setEditError(err.message);
    } finally {
      setSavingEdit(false);
    }
  };

  // ✅ submitAnmeldung FUNKTION mit Divisionen
  const submitAnmeldung = async () => {
    if (selectedWettkampfer.length === 0) {
      setError('Bitte wählen Sie mindestens einen Wettkämpfer aus.');
      return;
    }

    const isSmartModus = turnier.modus === 'smart';

    if (!alleHabenDivisionen()) {
      setError(isSmartModus
        ? 'Bitte wähle für jeden Wettkämpfer mindestens eine Disziplin aus.'
        : 'Bitte wählen Sie für jeden Wettkämpfer mindestens eine Division aus.'
      );
      return;
    }

    setSubmitting(true);
    try {
      const token = getAuthToken();

      if (!token) {
        throw new Error('Kein Authentifizierungstoken gefunden. Bitte loggen Sie sich erneut ein.');
      }

      let anmeldungData;
      if (isSmartModus) {
        anmeldungData = {
          turnier_id: turnier.turnier_id,
          verein_id: selectedVerein.vereins_id,
          wettkampfer_ids: selectedWettkampfer,
          wettkampfer_divisionen: [],
          wettkampfer_smart_disziplinen: selectedWettkampfer.map(wId => ({
            wettkaempfer_id: wId,
            disziplinen: smartDisziplinen[wId] || []
          })),
          anmelde_datum: new Date().toISOString(),
          is_update: !!editingWettkaempfer,
        };
      } else {
        const wettkampferMitDivisionen = selectedWettkampfer.map(wId => ({
          wettkaempfer_id: wId,
          divisionen: wettkampferDivisionen[wId]?.ausgewaehlt || []
        }));
        const teamDatenList = Object.entries(teamDaten).map(([key, data]) => {
          const [wkId, ...rest] = key.split('__');
          return { wettkaempfer_id: parseInt(wkId), division_code: rest.join('__'), team_name: data.teamName, mitglieder: data.mitglieder };
        });
        anmeldungData = {
          turnier_id: turnier.turnier_id,
          verein_id: selectedVerein.vereins_id,
          wettkampfer_ids: selectedWettkampfer,
          wettkampfer_divisionen: wettkampferMitDivisionen,
          anmelde_datum: new Date().toISOString(),
          is_update: !!editingWettkaempfer,
          ...(teamDatenList.length > 0 && { team_daten: teamDatenList })
        };
      }

      console.log('📝 Sende Anmeldung mit Divisionen:', anmeldungData);

      const response = await fetch(`/api/anmeldungen`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(anmeldungData)
      });

      console.log('📡 Anmeldung Response Status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('❌ Anmeldung Error:', errorData);
        throw new Error(errorData.message || `HTTP ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Anmeldung erfolgreich:', result);

      // Erfolg-Callback aufrufen
      if (onAnmeldungAbgeschlossen) {
        onAnmeldungAbgeschlossen({
          turnier,
          verein: selectedVerein,
          wettkampfer: selectedWettkampfer,
          divisionen: wettkampferDivisionen,
          anmeldung_id: result.data?.anmeldung_id
        });
      }

      onClose();
    } catch (err) {
      console.error('❌ Anmeldung fehlgeschlagen:', err);
      setError('Anmeldung fehlgeschlagen: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const filteredWettkampfer = wettkampfer.filter(w =>
    w.vorname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    w.nachname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    w.gurtfarbe?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    w.kampfstil?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const calculateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  // Passende Divisionen für einen einzelnen Wettkämpfer berechnen (nutzt bereits geladene alleDivisionen)
  const computePassendeDivisionen = (w) => {
    const skillLevelMapping = {
      'beginner': ['Beginner', 'Amateur', 'Rookie Grappling'],
      'intermediate': ['Intermediate', 'Amateur', 'Advanced Grappling'],
      'advanced': ['Advanced', 'Amateur', 'Master Grappling'],
      'black belt': ['Black Belts', 'Advanced', 'Master Grappling', 'Grand Champion']
    };
    const skillLevelMappingFormen = {
      'beginner': ['Beginner', 'Intermediate', 'Amateur', 'Rookie Grappling', 'Breaking'],
      'intermediate': ['Intermediate', 'Advanced', 'Amateur', 'Advanced Grappling', 'Breaking'],
      'advanced': ['Advanced', 'Black Belts', 'Amateur', 'Master Grappling', 'Breaking'],
      'black belt': ['Black Belts', 'Advanced', 'Master Grappling', 'Grand Champion', 'Breaking']
    };
    const formenTypes = ['Formen', 'Selbstverteidigung', 'Forms', 'Self Defense', 'Breaking', 'Bruchtest'];
    const kampfTypes = ['Kumite', 'Sparring', 'Fighting', 'Combat', 'Grappling', 'Kickboxen', 'Kickboxing', 'Pointfighting', 'Continous Fighting', 'Continuous Fighting', 'Fullcontact', 'Full Contact', 'K1', 'K-1', 'Rumble'];

    const alter = calculateAge(w.geburtsdatum);
    const gewicht = parseFloat(w.gewicht) || 0;
    const geschlecht = w.geschlecht?.toLowerCase();
    const skillLevel = w.skill_level?.toLowerCase();
    const skillLevelKata = (w.skill_level_kata || w.skill_level)?.toLowerCase();
    const skillLevelGrappling = (w.skill_level_grappling || w.skill_level)?.toLowerCase();

    return alleDivisionen.filter(div => {
      const divType = div.Division_Type || '';
      const isFormen = formenTypes.some(t => divType.toLowerCase().includes(t.toLowerCase()));
      const isKampf = kampfTypes.some(t => divType.toLowerCase().includes(t.toLowerCase()));

      const ageFrom = parseInt(div.Age_from);
      const ageTo = parseInt(div.Age_to);
      if (!isNaN(ageFrom) && !isNaN(ageTo)) {
        if (isKampf) {
          if (!(alter >= ageFrom && alter <= ageTo) && !(alter < ageFrom && alter >= ageFrom - 5)) return false;
        } else {
          if (alter < ageFrom || alter > ageTo) return false;
        }
      }

      const minWeight = parseFloat(div.Minimun_Weight);
      const maxWeight = parseFloat(div.Maximum_Weight);
      if (gewicht > 0 && !isNaN(minWeight) && !isNaN(maxWeight)) {
        if (isKampf) {
          if (!(gewicht >= minWeight && gewicht <= maxWeight) && !(gewicht < minWeight && gewicht >= minWeight - 10)) return false;
        } else {
          if (gewicht < minWeight || gewicht > maxWeight) return false;
        }
      }

      const relevantSkillLevel = isFormen ? skillLevelKata : (isKampf ? skillLevelGrappling : skillLevel);
      if (div.Skill_Level && relevantSkillLevel) {
        const erlaubteSkills = isFormen ? (skillLevelMappingFormen[relevantSkillLevel] || []) : (skillLevelMapping[relevantSkillLevel] || []);
        if (erlaubteSkills.length > 0 && !erlaubteSkills.includes(div.Skill_Level)) return false;
      }

      if (div.Gender && geschlecht) {
        const divGender = div.Gender.toLowerCase();
        if (divGender !== 'mixed' && divGender !== 'm/f' && divGender !== 'all' && divGender !== '') {
          const isMale = geschlecht === 'männlich' || geschlecht === 'm' || geschlecht === 'male';
          const isFemale = geschlecht === 'weiblich' || geschlecht === 'f' || geschlecht === 'female';
          const divIsMale = divGender === 'm' || divGender === 'male' || divGender === 'männlich';
          const divIsFemale = divGender === 'f' || divGender === 'female' || divGender === 'weiblich';
          if (divIsMale && isFemale) return false;
          if (divIsFemale && isMale) return false;
        }
      }
      return true;
    });
  };

  // ✅ DEBUGGING-FUNKTIONEN für Browser-Console
  React.useEffect(() => {
    // ✅ CORS-Test-Funktion
    window.testCORSHeaders = async () => {
      console.log('🧪 CORS-Header Test gestartet...');
      
      try {
        const token = getAuthToken();
        
        // ✅ EINFACHSTER MÖGLICHER REQUEST
        const response = await fetch(`/api/wettkaempfer/test`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
            // NUR Authorization-Header
          }
        });
        
        console.log('✅ CORS-Test erfolgreich, Status:', response.status);
        const data = await response.json();
        console.log('📊 Test-Data:', data);
        
        return true;
      } catch (error) {
        console.error('❌ CORS-Test fehlgeschlagen:', error);
        return false;
      }
    };

    // ✅ API-Test ohne Auth
    window.testAPIWithoutAuth = async (vereinId) => {
      console.log('🧪 Test API ohne Auth für Verein:', vereinId);
      
      try {
        const response = await fetch(`/api/wettkaempfer/verein/${vereinId}/noauth`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        console.log('📡 NoAuth Test Status:', response.status);
        
        if (response.ok) {
          const data = await response.json();
          console.log('✅ NoAuth Test erfolgreich:', data);
          return data;
        } else {
          console.log('❌ NoAuth Test fehlgeschlagen:', response.status);
          return null;
        }
      } catch (error) {
        console.error('❌ NoAuth Test Error:', error);
        return null;
      }
    };

    // Debug-Funktionen global verfügbar machen
    window.debugModalAuth = () => {
      console.log('🔍 Modal Auth-State Debugging:');
      console.log('📦 localStorage clubData:', localStorage.getItem('clubData'));
      console.log('📦 localStorage adminData:', localStorage.getItem('adminData'));
      console.log('🔑 Extrahierter Token:', getAuthToken());
      console.log('👤 User-Data:', getUserData());
      console.log('🎭 Current userRole:', userRole);
      console.log('🏢 Current userVereinId:', userVereinId);
    };

    window.testWettkampferAPI = async (vereinId) => {
      console.log('🧪 Testing Wettkämpfer API for Verein:', vereinId);
      try {
        const token = getAuthToken();
        const response = await fetch(`/api/wettkaempfer/verein/${vereinId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        console.log('📡 Status:', response.status);
        const data = await response.json();
        console.log('📊 Data:', data);
      } catch (error) {
        console.error('❌ Test Error:', error);
      }
    };

    console.log('🔧 Modal Debug-Funktionen verfügbar:');
    console.log('   debugModalAuth() - Zeigt Auth-Status');
    console.log('   testWettkampferAPI(vereinId) - Testet API direkt');
    console.log('   testCORSHeaders() - Testet CORS mit minimalen Headers');
    console.log('   testAPIWithoutAuth(9) - Testet API ohne Authorization');
  }, []);

  return (
    <div className={`modal-overlay ${currentStep === 3 ? 'fullscreen-overlay' : ''}`} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`modal-content ${currentStep === 3 ? 'fullscreen' : 'large'}`}>
        {/* Modal Header mit integriertem Progress */}
        <div className={`modal-header ${currentStep === 3 ? 'compact' : ''}`}>
          <div className="header-left">
            <div className="modal-title">
              <h2>🏆 Turnier-Anmeldung</h2>
              <p>{turnier.name} - {turnier.datum_formatted || new Date(turnier.datum).toLocaleDateString('de-DE')}</p>
            </div>
          </div>

          {/* Kompakter Progress Indicator im Header */}
          <div className="progress-indicator-compact">
            <div className={`step-compact ${currentStep >= 1 ? 'active' : ''} ${currentStep === 1 ? 'current' : ''}`}>
              <span className="step-dot">1</span>
              <span className="step-text">Verein</span>
            </div>
            <div className="step-line-compact"></div>
            <div className={`step-compact ${currentStep >= 2 ? 'active' : ''} ${currentStep === 2 ? 'current' : ''}`}>
              <span className="step-dot">2</span>
              <span className="step-text">Wettkämpfer</span>
            </div>
            <div className="step-line-compact"></div>
            <div className={`step-compact ${currentStep >= 3 ? 'active' : ''} ${currentStep === 3 ? 'current' : ''}`}>
              <span className="step-dot">3</span>
              <span className="step-text">Divisionen</span>
            </div>
          </div>

          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {/* Modal Body */}
        <div className="modal-body">
          {error && (
            <div className="error-message">
              <span>❌ {error}</span>
              <button onClick={() => setError('')}>✕</button>
            </div>
          )}
          {info && (
            <div className="info-message">
              <span>{info}</span>
            </div>
          )}

          {/* SCHRITT 1: Verein-Auswahl (nur Admin) */}
          {currentStep === 1 && userRole === 'admin' && (
            <div className="step-content">
              <h3>Verein für Anmeldung auswählen</h3>
              <p>Wählen Sie den Verein aus, für den Sie Wettkämpfer anmelden möchten:</p>
              
              {loading ? (
                <div className="loading-spinner-container">
                  <div className="loading-spinner"></div>
                  <p>Vereine werden geladen...</p>
                </div>
              ) : (
                <div className="vereine-grid">
                  {vereine.map(verein => (
                    <div 
                      key={verein.vereins_id}
                      className="verein-card selectable"
                      onClick={() => handleVereinSelect(verein)}
                    >
                      <div className="verein-info">
                        <h4>{verein.name}</h4>
                        <p>📍 {verein.ort}</p>
                        <p>👤 {verein.ansprechpartner}</p>
                      </div>
                      <div className="select-indicator">→</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* SCHRITT 2: Wettkämpfer-Auswahl */}
          {currentStep === 2 && selectedVerein && (
            <div className="step-content">
              <h3>Wettkämpfer von {selectedVerein.name} auswählen</h3>

              {/* Bereits angemeldete Kämpfer für dieses Turnier */}
              {Object.keys(bereitsAngemeldet).length > 0 && (() => {
                const bereitsIds = Object.keys(bereitsAngemeldet).map(Number);
                const bereitsWk = wettkampfer.filter(w => bereitsIds.includes(w.wettkaempfer_id));
                if (bereitsWk.length === 0) return null;
                return (
                  <div className="wkam-bereits-section">
                    <button
                      className="wkam-bereits-header-btn"
                      onClick={() => setBereitsSectionOpen(o => !o)}
                    >
                      <span className="wkam-section-arrow">{bereitsSectionOpen ? '▾' : '▸'}</span>
                      <span className="wkam-bereits-title">✓ Bereits angemeldet</span>
                      <span className="wkam-bereits-cnt">{bereitsWk.length}</span>
                    </button>
                    {bereitsSectionOpen && (
                      <div className="wkam-bereits-grid">
                        {bereitsWk.map(w => {
                          const wId = w.wettkaempfer_id;
                          const expanded = !!bereitsExpanded[wId];
                          const codes = bereitsAngemeldet[wId] || [];
                          const toggle = () => setBereitsExpanded(prev => ({ ...prev, [wId]: !prev[wId] }));
                          return (
                            <div key={wId} className={`wkam-bereits-card${expanded ? ' expanded' : ''}`}>
                              <div className="wkam-bereits-card-top" onClick={toggle}>
                                <span className="wkam-expand-arrow">{expanded ? '▾' : '▸'}</span>
                                <span className="wkam-bereits-name">{w.vorname} {w.nachname}</span>
                                {!expanded && <span className="wkam-div-count">{codes.length} Div.</span>}
                                <button
                                  className="wkam-nachmelden-btn"
                                  onClick={e => {
                                    e.stopPropagation();
                                    if (!selectedWettkampfer.includes(wId)) handleWettkampferToggle(wId);
                                  }}
                                >
                                  {selectedWettkampfer.includes(wId) ? '✓' : '+'}
                                </button>
                              </div>
                              {expanded && (
                                <div className="wkam-bereits-divs">
                                  {codes.map(code => (
                                    <span key={code} className="wkam-bereits-div-tag">{code}</span>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* Such- und Filter-Bereich */}
              <div className="wettkampfer-controls">
                <div className="search-container">
                  <input
                    ref={wettkampferSearchRef}
                    type="text"
                    placeholder="🔍 Wettkämpfer durchsuchen..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                </div>
                <div className="selection-info">
                  <span>{selectedWettkampfer.length} von {filteredWettkampfer.length} ausgewählt</span>
                  <button className="select-all-button" onClick={handleSelectAll}>
                    {selectedWettkampfer.length === filteredWettkampfer.length ? 'Alle abwählen' : 'Alle auswählen'}
                  </button>
                </div>
              </div>

              {loading ? (
                <div className="loading-spinner-container">
                  <div className="loading-spinner"></div>
                  <p>Wettkämpfer werden geladen...</p>
                </div>
              ) : filteredWettkampfer.length === 0 ? (
                <div className="no-wettkampfer">
                  <p>🤷‍♂️ Keine Wettkämpfer gefunden</p>
                  {searchTerm && <button onClick={() => setSearchTerm('')}>Suche zurücksetzen</button>}
                </div>
              ) : (
                <div className="wettkampfer-grid">
                  {[...filteredWettkampfer].sort((a, b) => {
                    const aS = selectedWettkampfer.includes(a.wettkaempfer_id);
                    const bS = selectedWettkampfer.includes(b.wettkaempfer_id);
                    return aS === bS ? 0 : aS ? -1 : 1;
                  }).map(w => {
                    const isSelected = selectedWettkampfer.includes(w.wettkaempfer_id);
                    const isNachmelden = isSelected && !!bereitsAngemeldet[w.wettkaempfer_id];
                    return (
                    <div
                      key={w.wettkaempfer_id}
                      className={`wettkampfer-card ${isSelected ? (isNachmelden ? 'nachmelden' : 'selected') : ''}`}
                      onClick={() => handleWettkampferToggle(w.wettkaempfer_id)}
                    >
                      <div className="wettkampfer-info">
                        <h4>
                          {isSelected && !isNachmelden && <span className="wk-selected-indicator">✓</span>}
                          {isNachmelden && <span className="wk-nachmelden-indicator">+ Nachm.</span>}
                          {w.vorname} {w.nachname}
                          {bereitsAngemeldet[w.wettkaempfer_id] && (
                            <span className="wkam-angemeldet-badge">
                              ✓ {bereitsAngemeldet[w.wettkaempfer_id].length} Div.
                            </span>
                          )}
                        </h4>
                        <div className="wettkampfer-details">
                          <span className="detail-item">🎂 {calculateAge(w.geburtsdatum)} Jahre</span>
                          <span className="detail-item">⚖️ {w.gewicht} kg</span>
                          <span className="detail-item">🥋 {w.gurtfarbe}</span>
                          <span className="detail-item">🏆 {w.skill_level}</span>
                          <span className="detail-item">🥊 {w.kampfstil}</span>
                        </div>
                      </div>
                      <button
                        className="wettkampfer-edit-btn"
                        onClick={(e) => { e.stopPropagation(); openEditModal(w); }}
                        title="Wettkämpfer bearbeiten"
                      >
                        ✏️
                      </button>
                    </div>
                    );
                  })}
                </div>
              )}
              {false && (
                <div className="sidebar-layout-REMOVED">
                  {/* ── Linke Sidebar: Athleten-Liste ── */}
                  <div className="wettkampfer-sidebar">
                    <div className="sidebar-header">
                      Wettkämpfer
                      {selectedWettkampfer.length > 0 && (
                        <span className="sidebar-selected-count">{selectedWettkampfer.length} ausgewählt</span>
                      )}
                    </div>

                    <div className="sidebar-search">
                      <input
                        ref={wettkampferSearchRef}
                        type="text"
                        placeholder="Suchen..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="sidebar-search-input"
                      />
                      {searchTerm && (
                        <button className="sidebar-search-clear" onClick={() => setSearchTerm('')}>✕</button>
                      )}
                    </div>

                    {/* Bereits angemeldet */}
                    {(() => {
                      const bereitsIds = Object.keys(bereitsAngemeldet).map(Number);
                      const bereitsWk = filteredWettkampfer.filter(w => bereitsIds.includes(w.wettkaempfer_id));
                      if (bereitsWk.length === 0) return null;
                      return (
                        <div className="sidebar-group">
                          <div className="sidebar-group-label">✓ Bereits angemeldet</div>
                          {bereitsWk.map(w => {
                            const wId = w.wettkaempfer_id;
                            const isActive = activeWettkampferTab === wId;
                            const divData = wettkampferDivisionen[wId] || { passend: [], ausgewaehlt: [] };
                            const newDivs = (divData.ausgewaehlt || []).filter(c => !bereitsAngemeldet[wId]?.includes(c));
                            return (
                              <div
                                key={wId}
                                className={`sidebar-item ${isActive ? 'active' : ''} ${selectedWettkampfer.includes(wId) ? 'has-selection' : ''}`}
                                onClick={() => activateAthlete(wId)}
                              >
                                <div className="sidebar-name-row">
                                  <span className="sidebar-name">{w.vorname} {w.nachname}</span>
                                  <button className="wk-edit-icon" onClick={(e) => { e.stopPropagation(); openEditModal(w); }} title="Bearbeiten">✏️</button>
                                  {selectedWettkampfer.includes(wId) && (
                                    <button className="wk-remove-btn" onClick={(e) => { e.stopPropagation(); removeWettkampferFromStep3(wId); }} title="Entfernen">✕</button>
                                  )}
                                </div>
                                <div className="sidebar-details">
                                  <span>{calculateAge(w.geburtsdatum)}J</span>
                                  <span>{w.gewicht}kg</span>
                                  <span>{w.geschlecht === 'männlich' ? '♂' : '♀'}</span>
                                </div>
                                <div className="sidebar-existing-divs">
                                  {bereitsAngemeldet[wId].slice(0, 4).map(code => (
                                    <span key={code} className="sidebar-div-tag">{code}</span>
                                  ))}
                                  {bereitsAngemeldet[wId].length > 4 && (
                                    <span className="sidebar-div-more">+{bereitsAngemeldet[wId].length - 4}</span>
                                  )}
                                </div>
                                {newDivs.length > 0 && <span className="sidebar-badge">+{newDivs.length}</span>}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}

                    {/* Weitere Kämpfer */}
                    {(() => {
                      const bereitsIds = Object.keys(bereitsAngemeldet).map(Number);
                      const weitereWk = filteredWettkampfer.filter(w => !bereitsIds.includes(w.wettkaempfer_id));
                      return (
                        <div className="sidebar-group">
                          {Object.keys(bereitsAngemeldet).length > 0 && (
                            <div className="sidebar-group-label">Weitere Kämpfer</div>
                          )}
                          {weitereWk.length === 0 && searchTerm && (
                            <div className="sidebar-empty">Keine Ergebnisse</div>
                          )}
                          {weitereWk.map(w => {
                            const wId = w.wettkaempfer_id;
                            const isActive = activeWettkampferTab === wId;
                            const divData = wettkampferDivisionen[wId] || { passend: [], ausgewaehlt: [] };
                            const hasSelection = divData.ausgewaehlt?.length > 0;
                            return (
                              <div
                                key={wId}
                                className={`sidebar-item ${isActive ? 'active' : ''} ${hasSelection ? 'has-selection' : ''}`}
                                onClick={() => activateAthlete(wId)}
                              >
                                <div className="sidebar-name-row">
                                  <span className="sidebar-name">{w.vorname} {w.nachname}</span>
                                  <button className="wk-edit-icon" onClick={(e) => { e.stopPropagation(); openEditModal(w); }} title="Bearbeiten">✏️</button>
                                  {selectedWettkampfer.includes(wId) && (
                                    <button className="wk-remove-btn" onClick={(e) => { e.stopPropagation(); removeWettkampferFromStep3(wId); }} title="Entfernen">✕</button>
                                  )}
                                </div>
                                <div className="sidebar-details">
                                  <span>{calculateAge(w.geburtsdatum)}J</span>
                                  <span>{w.gewicht}kg</span>
                                  <span>{w.geschlecht === 'männlich' ? '♂' : '♀'}</span>
                                  <span>{w.gurtfarbe}</span>
                                  <span>{w.skill_level}</span>
                                </div>
                                {hasSelection ? (
                                  <span className="sidebar-badge">{divData.ausgewaehlt.length}</span>
                                ) : divData.passend?.length > 0 ? (
                                  <span className="sidebar-warning">!</span>
                                ) : null}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>

                  {/* ── Rechtes Panel: Divisionen-Auswahl ── */}
                  <div className="division-main-area">
                    {!activeWettkampferTab ? (
                      <div className="division-empty-state">
                        <div className="division-empty-icon">👈</div>
                        <div className="division-empty-text">Kämpfer auswählen</div>
                        <div className="division-empty-sub">Klicke auf einen Kämpfer, um seine Divisionen anzuzeigen</div>
                      </div>
                    ) : (() => {
                      const w = wettkampfer.find(wk => wk.wettkaempfer_id === activeWettkampferTab);
                      if (!w) return null;
                      if (!wettkampferDivisionen[activeWettkampferTab] && loading) {
                        return (
                          <div className="loading-spinner-container">
                            <div className="loading-spinner"></div>
                            <p>Divisionen werden geladen...</p>
                          </div>
                        );
                      }
                      const divData = wettkampferDivisionen[activeWettkampferTab] || { passend: [], ausgewaehlt: [] };
                      const passendeDivisionen = divData.passend || [];
                      const ausgewaehlte = divData.ausgewaehlt || [];
                      const divisionenByType = passendeDivisionen.reduce((acc, div) => {
                        const type = div.Division_Type || 'Sonstige';
                        if (!acc[type]) acc[type] = [];
                        acc[type].push(div);
                        return acc;
                      }, {});

                      return (
                        <div className="division-content">
                          <div className="compact-action-bar">
                            <span className="division-stats">{ausgewaehlte.length}/{passendeDivisionen.length}</span>
                            <button className="btn-small" onClick={() => setShowSummary(true)}>📋 Übersicht</button>
                            <button className="btn-small" onClick={() => handleSelectAllDivisionen(activeWettkampferTab)}>
                              {ausgewaehlte.length === passendeDivisionen.length ? 'Keine' : 'Alle'}
                            </button>
                          </div>

                          {(() => {
                            const availableCategories = Object.keys(divisionenByType);
                            const allTournamentTypes = [...new Set(alleDivisionen.map(d => d.Division_Type || 'Sonstige'))];
                            const categoryMatches = {
                              formen: ['formen', 'forms', 'kata'],
                              kumite: ['kumite', 'sparring'],
                              kickboxen: ['kickboxen', 'kickboxing', 'pointfighting', 'point fighting', 'continuous', 'continous', 'fullcontact', 'full contact', 'k1', 'k-1'],
                              grappling: ['grappling', 'wrestling', 'bjj'],
                              rumble: ['rumble'],
                              selbstverteidigung: ['selbstverteidigung', 'self defense', 'self-defense', 'sv'],
                              bruchtest: ['bruchtest', 'breaking', 'break']
                            };
                            const isCategoryAvailable = (catId) => {
                              const matches = categoryMatches[catId] || [catId];
                              return allTournamentTypes.some(ac => matches.some(m => ac.toLowerCase().includes(m)));
                            };
                            const getMatchingTypes = (catId) => {
                              const matches = categoryMatches[catId] || [catId];
                              return availableCategories.filter(ac => matches.some(m => ac.toLowerCase().includes(m)));
                            };
                            const mainCategories = [
                              { id: 'alle', label: 'Alle', icon: '📋' },
                              { id: 'formen', label: 'Formen', icon: '🥋' },
                              { id: 'kumite', label: 'Kumite', icon: '👊' },
                              { id: 'kickboxen', label: 'Kickboxen', icon: '🥊' },
                              { id: 'grappling', label: 'Grappling', icon: '🤼' },
                              { id: 'selbstverteidigung', label: 'Selbstvert.', icon: '🛡️' },
                              { id: 'bruchtest', label: 'Bruchtest', icon: '🧱' },
                              { id: 'rumble', label: 'Rumble', icon: '💥' }
                            ].filter(cat => cat.id === 'alle' || isCategoryAvailable(cat.id));
                            return (
                              <div className="main-category-tabs">
                                {mainCategories.map(cat => {
                                  const matchingTypes = getMatchingTypes(cat.id);
                                  const count = cat.id === 'alle'
                                    ? passendeDivisionen.length
                                    : matchingTypes.reduce((sum, type) => sum + (divisionenByType[type] || []).length, 0);
                                  return (
                                    <button
                                      key={cat.id}
                                      className={`main-category-tab ${activeMainCategory === cat.id ? 'active' : ''}`}
                                      onClick={() => setActiveMainCategory(cat.id)}
                                    >
                                      <span className="cat-icon">{cat.icon}</span>
                                      <span className="cat-label">{cat.label}</span>
                                      <span className="cat-count">{count}</span>
                                    </button>
                                  );
                                })}
                              </div>
                            );
                          })()}

                          <div className="division-toolbar">
                            <div className="division-search">
                              <input
                                type="text"
                                placeholder="🔍 Division suchen..."
                                value={divisionSearch}
                                onChange={(e) => setDivisionSearch(e.target.value)}
                                className="division-search-input"
                              />
                              {divisionSearch && (
                                <button className="clear-search" onClick={() => setDivisionSearch('')}>✕</button>
                              )}
                            </div>
                            <div className="division-sort">
                              <label>Sortieren:</label>
                              <select value={divisionSort} onChange={(e) => setDivisionSort(e.target.value)} className="sort-select">
                                <option value="code">Code (A-Z)</option>
                                <option value="alter">Alter</option>
                                <option value="gewicht">Gewicht</option>
                                <option value="skill">Skill-Level</option>
                                <option value="favoriten">Favoriten zuerst</option>
                              </select>
                            </div>
                          </div>

                          {passendeDivisionen.length === 0 ? (
                            <div className="no-divisions-warning">
                              ⚠️ Keine passenden Divisionen für diesen Wettkämpfer gefunden
                            </div>
                          ) : (() => {
                            const catMatches = {
                              formen: ['formen', 'forms', 'kata'],
                              kumite: ['kumite', 'sparring'],
                              kickboxen: ['kickboxen', 'kickboxing', 'pointfighting', 'point fighting', 'continuous', 'continous', 'fullcontact', 'full contact', 'k1', 'k-1'],
                              grappling: ['grappling', 'wrestling', 'bjj'],
                              rumble: ['rumble'],
                              selbstverteidigung: ['selbstverteidigung', 'self defense', 'self-defense', 'sv'],
                              bruchtest: ['bruchtest', 'breaking', 'break']
                            };
                            const typeMatchesMain = (type) => {
                              if (activeMainCategory === 'alle') return true;
                              const m = catMatches[activeMainCategory] || [activeMainCategory];
                              return m.some(k => type.toLowerCase().includes(k));
                            };
                            const getSubKat = (typeLower) => ({
                              formen: [
                                { id: 'alle', label: 'Alle', filter: () => true },
                                { id: 'japanese', label: 'Japanese', filter: (d) => d.Division_Name?.toLowerCase().includes('japanese') && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                                { id: 'korean', label: 'Korean', filter: (d) => d.Division_Name?.toLowerCase().includes('korean') && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                                { id: 'chinese', label: 'Chinese/Kenpo', filter: (d) => (d.Division_Name?.toLowerCase().includes('chinese') || d.Division_Name?.toLowerCase().includes('kenpo') || d.Division_Name?.toLowerCase().includes('kempo')) && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                                { id: 'weapons', label: 'Weapons', filter: (d) => d.Division_Name?.toLowerCase().includes('weapon') && !d.Division_Name?.toLowerCase().includes('non') && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                                { id: 'open', label: 'Open/Creative', filter: (d) => (d.Division_Name?.toLowerCase().includes('open') || d.Division_Name?.toLowerCase().includes('creative') || d.Division_Name?.toLowerCase().includes('music')) && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                                { id: 'duo', label: 'Duo (alle)', filter: (d) => d.Division_Name?.toLowerCase().includes('duo') },
                                { id: 'duo-w', label: 'Duo Weapons', filter: (d) => d.Division_Name?.toLowerCase().includes('duo') && d.Division_Name?.toLowerCase().includes('weapon') && !d.Division_Name?.toLowerCase().includes('non') },
                                { id: 'duo-nw', label: 'Duo non-W.', filter: (d) => d.Division_Name?.toLowerCase().includes('duo') && (d.Division_Name?.toLowerCase().includes('non') || !d.Division_Name?.toLowerCase().includes('weapon')) },
                                { id: 'team', label: 'Team (alle)', filter: (d) => d.Division_Name?.toLowerCase().includes('team') },
                                { id: 'team-w', label: 'Team Weapons', filter: (d) => d.Division_Name?.toLowerCase().includes('team') && d.Division_Name?.toLowerCase().includes('weapon') && !d.Division_Name?.toLowerCase().includes('non') },
                                { id: 'team-nw', label: 'Team non-W.', filter: (d) => d.Division_Name?.toLowerCase().includes('team') && (d.Division_Name?.toLowerCase().includes('non') || !d.Division_Name?.toLowerCase().includes('weapon')) }
                              ],
                              bruchtest: [
                                { id: 'alle', label: 'Alle', filter: () => true },
                                { id: 'creative', label: 'Creative', filter: (d) => d.Division_Name?.toLowerCase().includes('creative') },
                                { id: 'wood', label: 'Wood', filter: (d) => d.Division_Name?.toLowerCase().includes('wood') }
                              ],
                              kickboxen: [
                                { id: 'alle', label: 'Alle', filter: () => true },
                                { id: 'pointfighting', label: 'Pointfighting', filter: (d) => d.Division_Name?.toLowerCase().includes('point') },
                                { id: 'continuous', label: 'Continuous', filter: (d) => d.Division_Name?.toLowerCase().includes('continu') },
                                { id: 'fullcontact', label: 'Fullcontact', filter: (d) => d.Division_Name?.toLowerCase().includes('fullcontact') || d.Division_Name?.toLowerCase().includes('full contact') },
                                { id: 'k1', label: 'K1', filter: (d) => d.Division_Name?.toLowerCase().includes('k1') || d.Division_Name?.toLowerCase().includes('k-1') }
                              ],
                              grappling: [
                                { id: 'alle', label: 'Alle', filter: () => true },
                                { id: 'nogi', label: 'No-Gi', filter: (d) => d.Division_Name?.toLowerCase().includes('no-gi') || d.Division_Name?.toLowerCase().includes('nogi') },
                                { id: 'gi', label: 'Gi', filter: (d) => d.Division_Name?.toLowerCase().includes('gi') && !d.Division_Name?.toLowerCase().includes('no-gi') && !d.Division_Name?.toLowerCase().includes('nogi') }
                              ],
                              kumite: [
                                { id: 'alle', label: 'Alle', filter: () => true },
                                { id: 'light', label: 'Light Contact', filter: (d) => d.Division_Name?.toLowerCase().includes('light') },
                                { id: 'semi', label: 'Semi Contact', filter: (d) => d.Division_Name?.toLowerCase().includes('semi') },
                                { id: 'full', label: 'Full Contact', filter: (d) => d.Division_Name?.toLowerCase().includes('full') }
                              ],
                              rumble: [{ id: 'alle', label: 'Alle', filter: () => true }]
                            }[typeLower] || null);

                            const visibleTypes = Object.entries(divisionenByType)
                              .filter(([type]) => typeMatchesMain(type) && divisionenByType[type]?.length > 0);

                            return (
                              <>
                                {activeMainCategory !== 'alle' && visibleTypes.map(([type, divs]) => {
                                  const typeLower = type.toLowerCase();
                                  const kategorien = getSubKat(typeLower);
                                  if (!kategorien || kategorien.length <= 1) return null;
                                  const activeFilter = categoryFilters[typeLower] || 'alle';
                                  const kategorieCounts = {};
                                  kategorien.forEach(k => { kategorieCounts[k.id] = divs.filter(k.filter).length; });
                                  return (
                                    <div key={`ft-${type}`} className="formen-filter-tabs">
                                      {kategorien.map(kat => (
                                        <button
                                          key={kat.id}
                                          className={`formen-filter-tab ${activeFilter === kat.id ? 'active' : ''}`}
                                          onClick={(e) => { e.stopPropagation(); setCategoryFilters(prev => ({ ...prev, [typeLower]: kat.id })); }}
                                        >
                                          {kat.label}
                                          <span className="filter-count">{kategorieCounts[kat.id]}</span>
                                        </button>
                                      ))}
                                    </div>
                                  );
                                })}
                                <div className="divisions-container">
                                  {visibleTypes.map(([type, divs]) => {
                                    const typeLower = type.toLowerCase();
                                    const kategorien = getSubKat(typeLower);
                                    const hasSubKategorien = kategorien && kategorien.length > 1;
                                    const activeFilter = categoryFilters[typeLower] || 'alle';
                                    let filteredDivs = hasSubKategorien
                                      ? divs.filter(kategorien.find(k => k.id === activeFilter)?.filter || (() => true))
                                      : divs;
                                    filteredDivs = filterBySearch(filteredDivs);
                                    filteredDivs = sortDivisionen(filteredDivs);
                                    return (
                                      <div key={type} className="division-type-section">
                                        <div className="type-header">
                                          <h4>{type}</h4>
                                          <span className="type-count">
                                            {filteredDivs.length}{divisionSearch && filteredDivs.length !== divs.length ? ` / ${divs.length}` : ''} Divisionen
                                          </span>
                                        </div>
                                        {filteredDivs.length === 0 && divisionSearch && (
                                          <div className="no-search-results">Keine Divisionen gefunden für "{divisionSearch}"</div>
                                        )}
                                        {filteredDivs.length === 0 && !divisionSearch && hasSubKategorien && (
                                          <div className="no-filter-results">Keine Divisionen in dieser Kategorie</div>
                                        )}
                                        <div className="divisions-grid">
                                          {filteredDivs.map(div => {
                                            const isSelected = ausgewaehlte.includes(div.Division_Code);
                                            const isFavorit = favoriten.includes(div.Division_Code);
                                            return (
                                              <div
                                                key={div.Division_Code}
                                                className={`division-card ${isSelected ? 'selected' : ''} ${isFavorit ? 'favorit' : ''}`}
                                                onClick={() => handleDivisionToggle(activeWettkampferTab, div.Division_Code)}
                                              >
                                                <div className="division-checkbox">{isSelected ? '✓' : ''}</div>
                                                <button
                                                  className={`favorit-btn ${isFavorit ? 'active' : ''}`}
                                                  onClick={(e) => { e.stopPropagation(); toggleFavorit(div.Division_Code); }}
                                                  title={isFavorit ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen'}
                                                >
                                                  {isFavorit ? '★' : '☆'}
                                                </button>
                                                <div className="division-info">
                                                  <div className="division-code">{div.Division_Code}</div>
                                                  <div className="division-name">{div.Division_Name}</div>
                                                  {isSelected && teamDaten[`${activeWettkampferTab}__${div.Division_Code}`] && (
                                                    <div className="team-info-badge">
                                                      <span>🏅 {teamDaten[`${activeWettkampferTab}__${div.Division_Code}`].teamName}</span>
                                                      <button className="team-edit-btn" onClick={e => { e.stopPropagation(); setTeamModal({ wettkampferId: activeWettkampferTab, divisionCode: div.Division_Code, divisionName: div.Division_Name, mode: getTeamMode(div.Division_Name), editing: true }); }}>✏️</button>
                                                    </div>
                                                  )}
                                                  <div className="division-details">
                                                    {(() => {
                                                      const af = parseInt(div.Age_from); const at = parseInt(div.Age_to);
                                                      const ageText = div.Age?.trim();
                                                      if (ageText) return <span>🎂 {ageText}</span>;
                                                      if (!isNaN(af) && !isNaN(at)) return <span>🎂 {af}-{at} J</span>;
                                                      return null;
                                                    })()}
                                                    {(div.Minimun_Weight || div.Maximum_Weight) && (
                                                      <span>⚖️ {div.Minimun_Weight ?? '?'}-{div.Maximum_Weight ?? '?'} kg</span>
                                                    )}
                                                    {div.Skill_Level && <span>🏆 {div.Skill_Level}</span>}
                                                    {div.Gender && <span>👤 {div.Gender}</span>}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </>
                            );
                          })()}

                          {ausgewaehlte.length === 0 && passendeDivisionen.length > 0 && (
                            <div className="selection-warning">
                              ⚠️ Bitte mindestens eine Division für diesen Wettkämpfer auswählen
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* SCHRITT 2: Smart-Modus — Athleten-Auswahl */}
          {currentStep === 2 && selectedVerein && turnier.modus === 'smart' && (
            <div className="step-content">
              <h3>Wettkämpfer von {selectedVerein.name} auswählen</h3>

              <div className="wettkampfer-controls">
                <div className="search-container">
                  <input
                    ref={wettkampferSearchRef}
                    type="text"
                    placeholder="🔍 Wettkämpfer durchsuchen..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                </div>
                <div className="selection-info">
                  <span>{selectedWettkampfer.length} von {filteredWettkampfer.length} ausgewählt</span>
                  <button className="select-all-button" onClick={handleSelectAll}>
                    {selectedWettkampfer.length === filteredWettkampfer.length ? 'Alle abwählen' : 'Alle auswählen'}
                  </button>
                </div>
              </div>

              {loading ? (
                <div className="loading-spinner-container">
                  <div className="loading-spinner"></div>
                  <p>Wettkämpfer werden geladen...</p>
                </div>
              ) : filteredWettkampfer.length === 0 ? (
                <div className="no-wettkampfer">
                  <p>🤷‍♂️ Keine Wettkämpfer gefunden</p>
                  {searchTerm && <button onClick={() => setSearchTerm('')}>Suche zurücksetzen</button>}
                </div>
              ) : (
                <div className="wettkampfer-grid">
                  {filteredWettkampfer.map(w => (
                    <div
                      key={w.wettkaempfer_id}
                      className={`wettkampfer-card ${selectedWettkampfer.includes(w.wettkaempfer_id) ? 'selected' : ''}`}
                      onClick={() => handleWettkampferToggle(w.wettkaempfer_id)}
                    >
                      <div className="wettkampfer-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedWettkampfer.includes(w.wettkaempfer_id)}
                          onChange={() => handleWettkampferToggle(w.wettkaempfer_id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div className="wettkampfer-info">
                        <h4>
                          {w.vorname} {w.nachname}
                          {bereitsAngemeldet[w.wettkaempfer_id] && (
                            <span className="wkam-angemeldet-badge">
                              ✓ {bereitsAngemeldet[w.wettkaempfer_id].length} Div.
                            </span>
                          )}
                        </h4>
                        <div className="wettkampfer-details">
                          <span className="detail-item">🎂 {calculateAge(w.geburtsdatum)} Jahre</span>
                          <span className="detail-item">⚖️ {w.gewicht} kg</span>
                          <span className="detail-item">🥋 {w.gurtfarbe}</span>
                          <span className="detail-item">🏆 {w.skill_level}</span>
                          <span className="detail-item">🥊 {w.kampfstil}</span>
                        </div>
                      </div>
                      <button
                        className="wettkampfer-edit-btn"
                        onClick={(e) => { e.stopPropagation(); openEditModal(w); }}
                        title="Wettkämpfer bearbeiten"
                      >
                        ✏️
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Wettkämpfer-Bearbeitungs-Modal */}
          {editingWettkampfer && (
            <div className="wk-edit-overlay" onClick={() => setEditingWettkampfer(null)}>
              <div className="wk-edit-modal" onClick={(e) => e.stopPropagation()}>
                <div className="wk-edit-header">
                  <span className="wk-edit-title">Wettkämpfer bearbeiten</span>
                  <button className="wk-edit-close" onClick={() => setEditingWettkampfer(null)}>✕</button>
                </div>
                <form
                  className="wk-edit-form"
                  onSubmit={(e) => { e.preventDefault(); saveWettkampferEdit(); }}
                >
                  <div className="wk-edit-row">
                    <div className="wk-edit-field">
                      <label>Vorname *</label>
                      <input
                        type="text"
                        value={editFormData.vorname}
                        onChange={(e) => setEditFormData({...editFormData, vorname: e.target.value})}
                        required
                      />
                    </div>
                    <div className="wk-edit-field">
                      <label>Nachname *</label>
                      <input
                        type="text"
                        value={editFormData.nachname}
                        onChange={(e) => setEditFormData({...editFormData, nachname: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  <div className="wk-edit-row">
                    <div className="wk-edit-field">
                      <label>
                        Geburtsdatum *
                        {editFormData.geburtsdatum && (
                          <span className="wk-edit-age">
                            {Math.floor((new Date() - new Date(editFormData.geburtsdatum)) / (365.25*24*3600*1000))} J.
                          </span>
                        )}
                      </label>
                      <input
                        type="date"
                        value={editFormData.geburtsdatum}
                        onChange={(e) => setEditFormData({...editFormData, geburtsdatum: e.target.value})}
                        required
                      />
                    </div>
                    <div className="wk-edit-field">
                      <label>Geschlecht</label>
                      <select
                        value={editFormData.geschlecht}
                        onChange={(e) => setEditFormData({...editFormData, geschlecht: e.target.value})}
                      >
                        <option value="männlich">Männlich</option>
                        <option value="weiblich">Weiblich</option>
                        <option value="divers">Divers</option>
                      </select>
                    </div>
                  </div>
                  <div className="wk-edit-row">
                    <div className="wk-edit-field">
                      <label>Formen-Level</label>
                      <select
                        value={editFormData.skill_level_kata}
                        onChange={(e) => setEditFormData({...editFormData, skill_level_kata: e.target.value})}
                      >
                        <option value="">— nicht gesetzt —</option>
                        {(skillGroups.kata || []).map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div className="wk-edit-field">
                      <label>Grappling-Level</label>
                      <select
                        value={editFormData.skill_level_grappling}
                        onChange={(e) => setEditFormData({...editFormData, skill_level_grappling: e.target.value})}
                      >
                        <option value="">— nicht gesetzt —</option>
                        {(skillGroups.grappling || []).map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="wk-edit-row">
                    <div className="wk-edit-field">
                      <label>Gewicht (kg)</label>
                      <input
                        type="number"
                        step="0.1"
                        min="20"
                        max="200"
                        value={editFormData.gewicht}
                        onChange={(e) => setEditFormData({...editFormData, gewicht: e.target.value})}
                        placeholder="z.B. 65"
                      />
                    </div>
                    <div className="wk-edit-field">
                      <label>Gurtfarbe</label>
                      <select
                        value={editFormData.gurtfarbe}
                        onChange={(e) => setEditFormData({...editFormData, gurtfarbe: e.target.value})}
                      >
                        <option value="">— nicht gesetzt —</option>
                        <option>Weiß</option>
                        <option>Weiß/Gelb</option>
                        <option>Gelb</option>
                        <option>Orange</option>
                        <option>Gelb/Grün</option>
                        <option>Grün</option>
                        <option>Grün/Blau</option>
                        <option>Blau</option>
                        <option>Braun</option>
                        <option>Rot/Braun</option>
                        <option>Blau/Rot</option>
                        <option>Rot</option>
                        <option>Rot/Schwarz</option>
                        <option>Schwarz</option>
                      </select>
                      <span className="wk-edit-hint">Höchsten Gurt aller Stilrichtungen</span>
                    </div>
                  </div>
                  <div className="wk-edit-field wk-edit-field--full">
                    <label>E-Mail</label>
                    <input
                      type="email"
                      value={editFormData.email}
                      onChange={(e) => setEditFormData({...editFormData, email: e.target.value})}
                      placeholder="optional"
                    />
                  </div>
                  <div className="wk-edit-field wk-edit-field--full">
                    <label>Handy</label>
                    <input
                      type="tel"
                      value={editFormData.handy}
                      onChange={(e) => setEditFormData({...editFormData, handy: e.target.value})}
                      placeholder="optional"
                    />
                  </div>
                  {editError && (
                    <div style={{ color: '#ef4444', fontSize: '0.82rem', padding: '0.5rem 0', borderTop: '1px solid rgba(239,68,68,0.2)' }}>
                      ⚠ {editError}
                    </div>
                  )}
                  <div className="wk-edit-actions">
                    <button type="button" className="wk-edit-btn-cancel" onClick={() => setEditingWettkampfer(null)}>
                      Abbrechen
                    </button>
                    <button type="submit" className="wk-edit-btn-save" disabled={savingEdit}>
                      {savingEdit ? '⏳ Speichern...' : '💾 Speichern'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* SCHRITT 3: Disziplinen/Divisionen-Auswahl */}
          {currentStep === 3 && turnier.modus === 'smart' && (() => {
            const verfuegbareDisziplinen = turnier.disziplin
              ? turnier.disziplin.split(',').map(s => s.trim()).filter(Boolean)
              : [];
            const KAMPF_DISC = ['Kumite', 'Grappling', 'Pointfighting', 'Continous Fighting', 'Fullcontact', 'K1', 'Rumble'];
            const isKampf = (disc) => KAMPF_DISC.some(k => disc.toLowerCase().includes(k.toLowerCase()));

            // Only Teamformen needs team member inputs
            // (Selbstverteidigung: partner assignment handled at event)
            const getTeamConfig = (disc) => {
              const d = disc.toLowerCase();
              if (d === 'teamformen') return { typ: 'wählbar' };
              return null;
            };

            const getEntry = (wId, disc) => (smartDisziplinen[wId] || []).find(e => e.disziplin === disc);
            const isSelected = (wId, disc) => !!getEntry(wId, disc);

            const defaultSlots = (teamCfg, teamTyp) => {
              if (teamCfg?.typ === 'partner') return [''];
              if (teamTyp === 'duo') return [''];
              return ['', ''];
            };

            const toggleDisc = (wId, disc) => setSmartDisziplinen(prev => {
              const cur = prev[wId] || [];
              if (cur.find(e => e.disziplin === disc)) {
                return { ...prev, [wId]: cur.filter(e => e.disziplin !== disc) };
              }
              const teamCfg = getTeamConfig(disc);
              const defaultTyp = teamCfg?.typ === 'wählbar' ? 'duo' : teamCfg?.typ || null;
              const entry = { disziplin: disc, level: ['eigen'], altersklasse: ['eigen'] };
              if (teamCfg) { entry.team_typ = defaultTyp; entry.team_mitglieder = defaultSlots(teamCfg, defaultTyp); }
              return { ...prev, [wId]: [...cur, entry] };
            });

            const togglePref = (wId, disc, field, value) => setSmartDisziplinen(prev => {
              const cur = prev[wId] || [];
              return {
                ...prev,
                [wId]: cur.map(e => {
                  if (e.disziplin !== disc) return e;
                  const arr = e[field] || [];
                  const updated = arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];
                  return { ...e, [field]: updated.length > 0 ? updated : arr };
                })
              };
            });

            const setTeamTyp = (wId, disc, typ) => setSmartDisziplinen(prev => ({
              ...prev,
              [wId]: (prev[wId] || []).map(e => e.disziplin !== disc ? e : {
                ...e, team_typ: typ, team_mitglieder: defaultSlots(null, typ)
              })
            }));

            const setMitglied = (wId, disc, idx, val) => setSmartDisziplinen(prev => ({
              ...prev,
              [wId]: (prev[wId] || []).map(e => {
                if (e.disziplin !== disc) return e;
                const arr = [...(e.team_mitglieder || [])];
                arr[idx] = val;
                return { ...e, team_mitglieder: arr };
              })
            }));

            const addMitglied = (wId, disc) => setSmartDisziplinen(prev => ({
              ...prev,
              [wId]: (prev[wId] || []).map(e => e.disziplin !== disc ? e : {
                ...e, team_mitglieder: [...(e.team_mitglieder || []), '']
              })
            }));

            const removeMitglied = (wId, disc, idx) => setSmartDisziplinen(prev => ({
              ...prev,
              [wId]: (prev[wId] || []).map(e => {
                if (e.disziplin !== disc) return e;
                const arr = (e.team_mitglieder || []).filter((_, i) => i !== idx);
                return { ...e, team_mitglieder: arr.length > 0 ? arr : [''] };
              })
            }));

            // Bidirektionale Team-Sync: wenn Athlet A Person B auswählt,
            // bekommt B automatisch dieselbe Disziplin mit A als Partner
            const syncPartner = (mainWId, disc, partnerFighter) => {
              if (!selectedWettkampfer.includes(partnerFighter.wettkaempfer_id)) return;
              const mainFighter = wettkampfer.find(wk => wk.wettkaempfer_id === mainWId);
              if (!mainFighter) return;
              const mainName = `${mainFighter.vorname} ${mainFighter.nachname}`;
              setSmartDisziplinen(prev => {
                const cur = prev[partnerFighter.wettkaempfer_id] || [];
                const existing = cur.find(e => e.disziplin === disc);
                if (existing) {
                  return { ...prev, [partnerFighter.wettkaempfer_id]: cur.map(e =>
                    e.disziplin !== disc ? e : { ...e, team_mitglieder: [mainName] }
                  )};
                }
                return { ...prev, [partnerFighter.wettkaempfer_id]: [
                  ...cur,
                  { disziplin: disc, level: ['eigen'], altersklasse: ['eigen'], team_typ: 'duo', team_mitglieder: [mainName] }
                ]};
              });
            };

            return (
              <div className="step-content">
                <h3>Disziplinen &amp; Startklasse auswählen</h3>
                <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.88rem', marginBottom: '0.75rem' }}>
                  Wähle für jeden Wettkämpfer die Disziplinen und die gewünschte Startklasse aus. Die Kategorien werden beim Auslosen entsprechend gebildet.
                </p>
                <div className="smart-notice">
                  <span className="smart-notice-icon">ℹ</span>
                  <span>
                    <strong>Hinweis zur Kategorienzuteilung:</strong> Die Einteilung erfolgt anhand von Alter, Gewicht und Level deiner Wettkämpfer.
                    Bitte stelle sicher, dass die Stammdaten aktuell sind. Bei Fragen zur Zuteilung wende dich vor dem Turnier an die Turnierleitung.
                  </span>
                </div>
                {selectedWettkampfer.map(wId => {
                  const w = wettkampfer.find(wk => wk.wettkaempfer_id === wId);
                  if (!w) return null;
                  const count = (smartDisziplinen[wId] || []).length;
                  return (
                    <div key={wId} className="smart-wk-block">
                      <div className="smart-wk-header">
                        <span className="smart-wk-name">{w.vorname} {w.nachname}</span>
                        <span className="smart-wk-meta">{calculateAge(w.geburtsdatum)} J · {w.gewicht} kg · {w.geschlecht === 'männlich' ? '♂' : '♀'}</span>
                        {count > 0 && <span className="smart-wk-badge">{count} Disziplinen</span>}
                        <button className="wk-remove-btn" onClick={() => removeWettkampferFromStep3(wId)} title="Wettkämpfer entfernen">✕</button>
                      </div>
                      <div className="smart-disc-grid">
                        {verfuegbareDisziplinen.map(disc => {
                          const sel = isSelected(wId, disc);
                          const entry = getEntry(wId, disc);
                          const kampf = isKampf(disc);
                          return (
                            <div key={disc} className={`smart-disc-card ${sel ? 'smart-disc-card--active' : ''}`}>
                              <label className="smart-disc-card-top" onClick={() => toggleDisc(wId, disc)}>
                                <span className={`smart-disc-check ${sel ? 'checked' : ''}`}>{sel ? '✓' : ''}</span>
                                <span className="smart-disc-name">{disc}</span>
                              </label>
                              {sel && (() => {
                                const teamCfg = getTeamConfig(disc);
                                return (
                                  <div className="smart-disc-prefs">
                                    {/* Level + AK Präferenz */}
                                    <div className="smart-pref-row">
                                      <button
                                        className={`smart-pref-btn ${(entry.level || []).includes('eigen') ? 'active' : ''}`}
                                        onClick={() => togglePref(wId, disc, 'level', 'eigen')}
                                      >Eigene</button>
                                      <button
                                        className={`smart-pref-btn ${(entry.level || []).includes('hoeher') ? 'active' : ''}`}
                                        onClick={() => togglePref(wId, disc, 'level', 'hoeher')}
                                      >Höher</button>
                                      {kampf && (
                                        <button
                                          className={`smart-pref-btn ${(entry.altersklasse || []).includes('jünger') ? 'active' : ''}`}
                                          onClick={() => togglePref(wId, disc, 'altersklasse', 'jünger')}
                                        >Jüngere AK</button>
                                      )}
                                    </div>
                                    {/* Team-Mitglieder */}
                                    {teamCfg && (
                                      <div className="smart-team-section">
                                        {teamCfg.typ === 'wählbar' && (
                                          <div className="smart-pref-row" style={{ marginBottom: 6 }}>
                                            <button
                                              className={`smart-pref-btn ${entry.team_typ === 'duo' ? 'active' : ''}`}
                                              onClick={() => setTeamTyp(wId, disc, 'duo')}
                                            >Duo (2)</button>
                                            <button
                                              className={`smart-pref-btn ${entry.team_typ === 'team' ? 'active' : ''}`}
                                              onClick={() => setTeamTyp(wId, disc, 'team')}
                                            >Team (3+)</button>
                                          </div>
                                        )}
                                        <div className="smart-team-label">
                                          {teamCfg.typ === 'partner' ? 'Partner:' : 'Mitglieder:'}
                                        </div>
                                        {(entry.team_mitglieder || []).map((m, idx) => {
                                          const refKey = `${wId}_${disc}_${idx}`;
                                          const nextKey = `${wId}_${disc}_${idx + 1}`;
                                          return (
                                          <div key={idx} className="smart-team-row">
                                            <PersonSearchInput
                                              inputId={refKey}
                                              nextInputId={(entry.team_mitglieder || []).length > idx + 1 ? nextKey : null}
                                              value={m}
                                              onChange={val => setMitglied(wId, disc, idx, val)}
                                              onFighterSelected={fighter => syncPartner(wId, disc, fighter)}
                                              wettkampfer={wettkampfer.filter(wk => wk.wettkaempfer_id !== wId)}
                                              placeholder={`Person ${idx + 2}…`}
                                            />
                                            {teamCfg.typ !== 'partner' && (entry.team_mitglieder || []).length > (entry.team_typ === 'duo' ? 1 : 2) && (
                                              <button className="smart-team-remove" onClick={() => removeMitglied(wId, disc, idx)}>✕</button>
                                            )}
                                          </div>
                                          );
                                        })}
                                        {entry.team_typ === 'team' && (
                                          <button className="smart-team-add" onClick={() => addMitglied(wId, disc)}>
                                            + Person hinzufügen
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                );
                              })()}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}

          {currentStep === 3 && turnier.modus !== 'smart' && (
            <div className="step-content fullscreen-step">
              {loading ? (
                <div className="loading-spinner-container">
                  <div className="loading-spinner"></div>
                  <p>Divisionen werden geladen und gefiltert...</p>
                </div>
              ) : (
                <div className="sidebar-layout">
                  {/* Wettkämpfer Sidebar Links */}
                  <div className="wettkampfer-sidebar">
                    <div className="sidebar-header">Wettkämpfer</div>
                    {selectedWettkampfer.map(wId => {
                      const w = wettkampfer.find(wk => wk.wettkaempfer_id === wId);
                      if (!w) return null;
                      const divData = wettkampferDivisionen[wId] || { passend: [], ausgewaehlt: [] };
                      const isActive = activeWettkampferTab === wId;
                      const hasSelection = divData.ausgewaehlt?.length > 0;

                      return (
                        <div
                          key={wId}
                          className={`sidebar-item ${isActive ? 'active' : ''} ${hasSelection ? 'has-selection' : ''}`}
                          onClick={() => { setActiveWettkampferTab(wId); setCategoryFilters({}); setActiveMainCategory('alle'); }}
                        >
                          <div className="sidebar-name-row">
                            <span className="sidebar-name">{w.vorname} {w.nachname}</span>
                            <button className="wk-remove-btn" onClick={e => { e.stopPropagation(); removeWettkampferFromStep3(wId); }} title="Entfernen">✕</button>
                          </div>
                          <div className="sidebar-details">
                            <span>{calculateAge(w.geburtsdatum)}J</span>
                            <span>{w.gewicht}kg</span>
                            <span>{w.geschlecht === 'männlich' ? '♂' : w.geschlecht === 'weiblich' ? '♀' : ''}</span>
                          </div>
                          <div className="sidebar-details">
                            <span>{w.gurtfarbe}</span>
                            <span>{w.skill_level}</span>
                          </div>
                          {hasSelection ? (
                            <span className="sidebar-badge">{divData.ausgewaehlt.length}</span>
                          ) : divData.passend?.length > 0 ? (
                            <span className="sidebar-warning">!</span>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>

                  {/* Divisionen-Bereich Rechts */}
                  <div className="division-main-area">
                  {activeWettkampferTab && (() => {
                    const w = wettkampfer.find(wk => wk.wettkaempfer_id === activeWettkampferTab);
                    if (!w) return null;
                    const divData = wettkampferDivisionen[activeWettkampferTab] || { passend: [], ausgewaehlt: [] };
                    const passendeDivisionen = divData.passend || [];
                    const ausgewaehlte = divData.ausgewaehlt || [];

                    // Gruppiere nach Division_Type
                    const divisionenByType = passendeDivisionen.reduce((acc, div) => {
                      const type = div.Division_Type || 'Sonstige';
                      if (!acc[type]) acc[type] = [];
                      acc[type].push(div);
                      return acc;
                    }, {});

                    return (
                      <div className="division-content">
                        {/* Kompakte Aktionsleiste */}
                        <div className="compact-action-bar">
                          <span className="division-stats">{ausgewaehlte.length}/{passendeDivisionen.length}</span>
                          <button className="btn-small" onClick={() => setShowSummary(true)}>📋 Übersicht</button>
                          <button className="btn-small" onClick={() => handleSelectAllDivisionen(activeWettkampferTab)}>
                            {ausgewaehlte.length === passendeDivisionen.length ? 'Keine' : 'Alle'}
                          </button>
                        </div>

                        {/* Haupt-Kategorie-Tabs */}
                        {(() => {
                          // Sammle verfügbare Kategorien aus passenden UND allen Divisionen
                          const availableCategories = Object.keys(divisionenByType);
                          // Alle Divisionen im Turnier (unabhängig vom Wettkämpfer) für Tab-Sichtbarkeit
                          const allTournamentTypes = [...new Set(alleDivisionen.map(d => d.Division_Type || 'Sonstige'))];

                          // Mapping von Tab-ID zu möglichen Division_Type Namen
                          const categoryMatches = {
                            formen: ['formen', 'forms', 'kata'],
                            kumite: ['kumite', 'sparring'],
                            kickboxen: ['kickboxen', 'kickboxing', 'pointfighting', 'point fighting', 'continuous', 'continous', 'fullcontact', 'full contact', 'k1', 'k-1'],
                            grappling: ['grappling', 'wrestling', 'bjj'],
                            rumble: ['rumble'],
                            selbstverteidigung: ['selbstverteidigung', 'self defense', 'self-defense', 'sv'],
                            bruchtest: ['bruchtest', 'breaking', 'break']
                          };

                          // Prüfe ob eine Kategorie im Turnier vorhanden ist (auch wenn kein Match für diesen Kämpfer)
                          const isCategoryAvailable = (catId) => {
                            const matches = categoryMatches[catId] || [catId];
                            return allTournamentTypes.some(ac =>
                              matches.some(m => ac.toLowerCase().includes(m))
                            );
                          };

                          // Finde passende Division_Type Namen für eine Kategorie (aus passenden Divisionen)
                          const getMatchingTypes = (catId) => {
                            const matches = categoryMatches[catId] || [catId];
                            return availableCategories.filter(ac =>
                              matches.some(m => ac.toLowerCase().includes(m))
                            );
                          };

                          const mainCategories = [
                            { id: 'alle', label: 'Alle', icon: '📋' },
                            { id: 'formen', label: 'Formen', icon: '🥋' },
                            { id: 'kumite', label: 'Kumite', icon: '👊' },
                            { id: 'kickboxen', label: 'Kickboxen', icon: '🥊' },
                            { id: 'grappling', label: 'Grappling', icon: '🤼' },
                            { id: 'selbstverteidigung', label: 'Selbstvert.', icon: '🛡️' },
                            { id: 'bruchtest', label: 'Bruchtest', icon: '🧱' },
                            { id: 'rumble', label: 'Rumble', icon: '💥' }
                          ].filter(cat => cat.id === 'alle' || isCategoryAvailable(cat.id));

                          return (
                            <div className="main-category-tabs">
                              {mainCategories.map(cat => {
                                const matchingTypes = getMatchingTypes(cat.id);
                                const count = cat.id === 'alle'
                                  ? passendeDivisionen.length
                                  : matchingTypes.reduce((sum, type) => sum + (divisionenByType[type] || []).length, 0);
                                return (
                                  <button
                                    key={cat.id}
                                    className={`main-category-tab ${activeMainCategory === cat.id ? 'active' : ''}`}
                                    onClick={() => setActiveMainCategory(cat.id)}
                                  >
                                    <span className="cat-icon">{cat.icon}</span>
                                    <span className="cat-label">{cat.label}</span>
                                    <span className="cat-count">{count}</span>
                                  </button>
                                );
                              })}
                            </div>
                          );
                        })()}

                        {/* Such- und Sortier-Bereich */}
                        <div className="division-toolbar">
                          <div className="division-search">
                            <input
                              type="text"
                              placeholder="🔍 Division suchen..."
                              value={divisionSearch}
                              onChange={(e) => setDivisionSearch(e.target.value)}
                              className="division-search-input"
                            />
                            {divisionSearch && (
                              <button className="clear-search" onClick={() => setDivisionSearch('')}>✕</button>
                            )}
                          </div>
                          <div className="division-sort">
                            <label>Sortieren:</label>
                            <select
                              value={divisionSort}
                              onChange={(e) => setDivisionSort(e.target.value)}
                              className="sort-select"
                            >
                              <option value="code">Code (A-Z)</option>
                              <option value="alter">Alter</option>
                              <option value="gewicht">Gewicht</option>
                              <option value="skill">Skill-Level</option>
                              <option value="favoriten">Favoriten zuerst</option>
                            </select>
                          </div>
                        </div>

                        {passendeDivisionen.length === 0 ? (
                          <div className="no-divisions-warning">
                            ⚠️ Keine passenden Divisionen für diesen Wettkämpfer gefunden
                          </div>
                        ) : (() => {
                          // Gemeinsames Mapping für Typ-Filter und Unterkategorien
                          const catMatches = {
                            formen: ['formen', 'forms', 'kata'],
                            kumite: ['kumite', 'sparring'],
                            kickboxen: ['kickboxen', 'kickboxing', 'pointfighting', 'point fighting', 'continuous', 'continous', 'fullcontact', 'full contact', 'k1', 'k-1'],
                            grappling: ['grappling', 'wrestling', 'bjj'],
                            rumble: ['rumble'],
                            selbstverteidigung: ['selbstverteidigung', 'self defense', 'self-defense', 'sv'],
                            bruchtest: ['bruchtest', 'breaking', 'break']
                          };
                          const typeMatchesMain = (type) => {
                            if (activeMainCategory === 'alle') return true;
                            const m = catMatches[activeMainCategory] || [activeMainCategory];
                            return m.some(k => type.toLowerCase().includes(k));
                          };
                          const getSubKat = (typeLower) => ({
                            formen: [
                              { id: 'alle', label: 'Alle', filter: () => true },
                              { id: 'japanese', label: 'Japanese', filter: (d) => d.Division_Name?.toLowerCase().includes('japanese') && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                              { id: 'korean', label: 'Korean', filter: (d) => d.Division_Name?.toLowerCase().includes('korean') && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                              { id: 'chinese', label: 'Chinese/Kenpo', filter: (d) => (d.Division_Name?.toLowerCase().includes('chinese') || d.Division_Name?.toLowerCase().includes('kenpo') || d.Division_Name?.toLowerCase().includes('kempo')) && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                              { id: 'weapons', label: 'Weapons', filter: (d) => d.Division_Name?.toLowerCase().includes('weapon') && !d.Division_Name?.toLowerCase().includes('non') && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                              { id: 'open', label: 'Open/Creative', filter: (d) => (d.Division_Name?.toLowerCase().includes('open') || d.Division_Name?.toLowerCase().includes('creative') || d.Division_Name?.toLowerCase().includes('music')) && !d.Division_Name?.toLowerCase().includes('duo') && !d.Division_Name?.toLowerCase().includes('team') },
                              { id: 'duo', label: 'Duo (alle)', filter: (d) => d.Division_Name?.toLowerCase().includes('duo') },
                              { id: 'duo-w', label: 'Duo Weapons', filter: (d) => d.Division_Name?.toLowerCase().includes('duo') && d.Division_Name?.toLowerCase().includes('weapon') && !d.Division_Name?.toLowerCase().includes('non') },
                              { id: 'duo-nw', label: 'Duo non-W.', filter: (d) => d.Division_Name?.toLowerCase().includes('duo') && (d.Division_Name?.toLowerCase().includes('non') || !d.Division_Name?.toLowerCase().includes('weapon')) },
                              { id: 'team', label: 'Team (alle)', filter: (d) => d.Division_Name?.toLowerCase().includes('team') },
                              { id: 'team-w', label: 'Team Weapons', filter: (d) => d.Division_Name?.toLowerCase().includes('team') && d.Division_Name?.toLowerCase().includes('weapon') && !d.Division_Name?.toLowerCase().includes('non') },
                              { id: 'team-nw', label: 'Team non-W.', filter: (d) => d.Division_Name?.toLowerCase().includes('team') && (d.Division_Name?.toLowerCase().includes('non') || !d.Division_Name?.toLowerCase().includes('weapon')) }
                            ],
                            bruchtest: [
                              { id: 'alle', label: 'Alle', filter: () => true },
                              { id: 'creative', label: 'Creative', filter: (d) => d.Division_Name?.toLowerCase().includes('creative') },
                              { id: 'wood', label: 'Wood', filter: (d) => d.Division_Name?.toLowerCase().includes('wood') }
                            ],
                            kickboxen: [
                              { id: 'alle', label: 'Alle', filter: () => true },
                              { id: 'pointfighting', label: 'Pointfighting', filter: (d) => d.Division_Name?.toLowerCase().includes('point') },
                              { id: 'continuous', label: 'Continuous', filter: (d) => d.Division_Name?.toLowerCase().includes('continu') },
                              { id: 'fullcontact', label: 'Fullcontact', filter: (d) => d.Division_Name?.toLowerCase().includes('fullcontact') || d.Division_Name?.toLowerCase().includes('full contact') },
                              { id: 'k1', label: 'K1', filter: (d) => d.Division_Name?.toLowerCase().includes('k1') || d.Division_Name?.toLowerCase().includes('k-1') }
                            ],
                            grappling: [
                              { id: 'alle', label: 'Alle', filter: () => true },
                              { id: 'nogi', label: 'No-Gi', filter: (d) => d.Division_Name?.toLowerCase().includes('no-gi') || d.Division_Name?.toLowerCase().includes('nogi') },
                              { id: 'gi', label: 'Gi', filter: (d) => d.Division_Name?.toLowerCase().includes('gi') && !d.Division_Name?.toLowerCase().includes('no-gi') && !d.Division_Name?.toLowerCase().includes('nogi') }
                            ],
                            kumite: [
                              { id: 'alle', label: 'Alle', filter: () => true },
                              { id: 'light', label: 'Light Contact', filter: (d) => d.Division_Name?.toLowerCase().includes('light') },
                              { id: 'semi', label: 'Semi Contact', filter: (d) => d.Division_Name?.toLowerCase().includes('semi') },
                              { id: 'full', label: 'Full Contact', filter: (d) => d.Division_Name?.toLowerCase().includes('full') }
                            ],
                            rumble: [{ id: 'alle', label: 'Alle', filter: () => true }]
                          }[typeLower] || null);

                          const visibleTypes = Object.entries(divisionenByType)
                            .filter(([type]) => typeMatchesMain(type) && divisionenByType[type]?.length > 0);

                          return (
                            <>
                              {/* Filter-Tabs AUSSERHALB des Scroll-Containers – kein overflow-Clipping */}
                              {visibleTypes.map(([type, divs]) => {
                                const typeLower = type.toLowerCase();
                                const kategorien = getSubKat(typeLower);
                                if (!kategorien || kategorien.length <= 1) return null;
                                const activeFilter = categoryFilters[typeLower] || 'alle';
                                const kategorieCounts = {};
                                kategorien.forEach(k => { kategorieCounts[k.id] = divs.filter(k.filter).length; });
                                return (
                                  <div key={`ft-${type}`} className="formen-filter-tabs">
                                    {kategorien.map(kat => (
                                      <button
                                        key={kat.id}
                                        className={`formen-filter-tab ${activeFilter === kat.id ? 'active' : ''}`}
                                        onClick={(e) => { e.stopPropagation(); setCategoryFilters(prev => ({ ...prev, [typeLower]: kat.id })); }}
                                      >
                                        {kat.label}
                                        <span className="filter-count">{kategorieCounts[kat.id]}</span>
                                      </button>
                                    ))}
                                  </div>
                                );
                              })}

                              {/* Scrollbarer Bereich nur für Division-Karten */}
                              <div className="divisions-container">
                                {visibleTypes.map(([type, divs]) => {
                                  const typeLower = type.toLowerCase();
                                  const kategorien = getSubKat(typeLower);
                                  const hasSubKategorien = kategorien && kategorien.length > 1;
                                  const activeFilter = categoryFilters[typeLower] || 'alle';
                                  let filteredDivs = hasSubKategorien
                                    ? divs.filter(kategorien.find(k => k.id === activeFilter)?.filter || (() => true))
                                    : divs;
                                  filteredDivs = filterBySearch(filteredDivs);
                                  filteredDivs = sortDivisionen(filteredDivs);

                                  return (
                                    <div key={type} className="division-type-section">
                                      <div className="type-header">
                                        <h4>{type}</h4>
                                        <span className="type-count">
                                          {filteredDivs.length}{divisionSearch && filteredDivs.length !== divs.length ? ` / ${divs.length}` : ''} Divisionen
                                        </span>
                                      </div>

                                      {filteredDivs.length === 0 && divisionSearch && (
                                        <div className="no-search-results">
                                          Keine Divisionen gefunden für "{divisionSearch}"
                                        </div>
                                      )}

                                      {filteredDivs.length === 0 && !divisionSearch && hasSubKategorien && (
                                        <div className="no-filter-results">
                                          Keine Divisionen in dieser Kategorie
                                        </div>
                                      )}

                                      <div className="divisions-grid">
                                        {filteredDivs.map(div => {
                                          const isSelected = ausgewaehlte.includes(div.Division_Code);
                                          const isFavorit = favoriten.includes(div.Division_Code);
                                          return (
                                            <div
                                              key={div.Division_Code}
                                              className={`division-card ${isSelected ? 'selected' : ''} ${isFavorit ? 'favorit' : ''}`}
                                              onClick={() => handleDivisionToggle(activeWettkampferTab, div.Division_Code)}
                                            >
                                              <div className="division-checkbox">{isSelected ? '✓' : ''}</div>
                                              <button
                                                className={`favorit-btn ${isFavorit ? 'active' : ''}`}
                                                onClick={(e) => { e.stopPropagation(); toggleFavorit(div.Division_Code); }}
                                                title={isFavorit ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen'}
                                              >
                                                {isFavorit ? '★' : '☆'}
                                              </button>
                                              <div className="division-info">
                                                <div className="division-code">{div.Division_Code}</div>
                                                <div className="division-name">{div.Division_Name}</div>
                                                {isSelected && teamDaten[`${activeWettkampferTab}__${div.Division_Code}`] && (
                                                  <div className="team-info-badge">
                                                    <span>🏅 {teamDaten[`${activeWettkampferTab}__${div.Division_Code}`].teamName}</span>
                                                    <button className="team-edit-btn" onClick={e => { e.stopPropagation(); setTeamModal({ wettkampferId: activeWettkampferTab, divisionCode: div.Division_Code, divisionName: div.Division_Name, mode: getTeamMode(div.Division_Name), editing: true }); }}>✏️</button>
                                                  </div>
                                                )}
                                                <div className="division-details">
                                                  {(() => {
                                                    const af = parseInt(div.Age_from); const at = parseInt(div.Age_to);
                                                    const ageText = div.Age?.trim();
                                                    if (ageText) return <span>🎂 {ageText}</span>;
                                                    if (!isNaN(af) && !isNaN(at)) return <span>🎂 {af}-{at} J</span>;
                                                    return null;
                                                  })()}
                                                  {(div.Minimun_Weight || div.Maximum_Weight) && (
                                                    <span>⚖️ {div.Minimun_Weight ?? '?'}-{div.Maximum_Weight ?? '?'} kg</span>
                                                  )}
                                                  {div.Skill_Level && <span>🏆 {div.Skill_Level}</span>}
                                                  {div.Gender && <span>👤 {div.Gender}</span>}
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </>
                          );
                        })()}

                        {ausgewaehlte.length === 0 && passendeDivisionen.length > 0 && (
                          <div className="selection-warning">
                            ⚠️ Bitte mindestens eine Division für diesen Wettkämpfer auswählen
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Zusammenfassungs-Modal */}
        {showSummary && (
          <div className="summary-overlay" onClick={() => setShowSummary(false)}>
            <div className="summary-modal" onClick={(e) => e.stopPropagation()}>
              <div className="summary-header">
                <h3>Anmeldungs-Übersicht</h3>
                <button className="close-summary" onClick={() => setShowSummary(false)}>✕</button>
              </div>
              <div className="summary-content">
                {getZusammenfassung().map(({ wettkampfer: w, divisionen }) => (
                  <div key={w?.wettkaempfer_id} className="summary-wettkampfer">
                    <div className="summary-wettkampfer-header">
                      <h4>{w?.vorname} {w?.nachname}</h4>
                      <span className="summary-badge">
                        {divisionen.length} Division{divisionen.length !== 1 ? 'en' : ''}
                      </span>
                    </div>
                    {divisionen.length === 0 ? (
                      <p className="summary-warning">Keine Divisionen ausgewählt</p>
                    ) : (
                      <ul className="summary-divisions">
                        {divisionen.map(div => {
                          const td = teamDaten[`${w?.wettkaempfer_id}__${div.Division_Code}`];
                          return (
                            <li key={div.Division_Code}>
                              <span className="summary-code">{div.Division_Code}</span>
                              <span className="summary-name">{div.Division_Name}</span>
                              {td && (
                                <span className="summary-team-info">
                                  🏅 <strong>{td.teamName}</strong>
                                  {td.mitglieder.filter(Boolean).length > 0 && (
                                    <span> · {td.mitglieder.filter(Boolean).join(', ')}</span>
                                  )}
                                </span>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="summary-footer">
                <div className="summary-total">
                  Gesamt: {selectedWettkampfer.length} Wettkämpfer, {' '}
                  {getZusammenfassung().reduce((sum, item) => sum + item.divisionen.length, 0)} Divisions-Anmeldungen
                </div>
                <button className="btn-primary" onClick={() => setShowSummary(false)}>
                  Schließen
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Team-Modal ── */}
        {teamModal && (
          <TeamModal
            divisionName={teamModal.divisionName}
            mode={teamModal.mode}
            initialData={teamDaten[`${teamModal.wettkampferId}__${teamModal.divisionCode}`]}
            onConfirm={confirmTeamModal}
            onCancel={() => setTeamModal(null)}
            wettkampfer={wettkampfer}
          />
        )}

        {/* Modal Footer */}
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Abbrechen
          </button>

          {currentStep === 1 && userRole === 'admin' && (
            <button
              className="btn-primary"
              disabled={!selectedVerein}
            >
              Verein auswählen →
            </button>
          )}

          {currentStep === 2 && (
            <>
              {userRole === 'admin' && (
                <button
                  className="btn-secondary"
                  onClick={() => setCurrentStep(1)}
                >
                  ← Zurück
                </button>
              )}
              <button
                className="btn-secondary"
                onClick={submitOhneKategorie}
                disabled={selectedWettkampfer.length === 0 || submitting}
                title="Anmelden ohne Kategorie – Kategorie kann später nachgetragen werden"
                style={{ borderColor: 'rgba(251,191,36,0.4)', color: '#fbbf24' }}
              >
                {submitting ? '⟳ …' : 'Ohne Kategorie anmelden'}
              </button>
              <button
                className="btn-primary"
                onClick={handleWeiterZuDivisionen}
                disabled={selectedWettkampfer.length === 0}
              >
                Weiter zu Divisionen →
              </button>
            </>
          )}

          {currentStep === 3 && (
            <>
              <button
                className="btn-secondary"
                onClick={() => setCurrentStep(2)}
              >
                ← Zurück
              </button>
              <button
                className="btn-primary"
                onClick={submitAnmeldung}
                disabled={!alleHabenDivisionen() || submitting}
              >
                {submitting ? (
                  <>⏳ Anmeldung läuft...</>
                ) : turnier.modus === 'smart' ? (
                  <>✅ {selectedWettkampfer.length} Wettkämpfer anmelden</>
                ) : (
                  <>✅ {selectedWettkampfer.length} Wettkämpfer anmelden</>
                )}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// ── Autocomplete-Input für Vereinsmitglieder ────────────────────────────────
function PersonSearchInput({ value, onChange, onFighterSelected, wettkampfer, placeholder, inputId, nextInputId }) {
  const [query, setQuery] = useState(value || '');
  const [open, setOpen] = useState(false);
  const inputRef = React.useRef(null);

  useEffect(() => { setQuery(value || ''); }, [value]);

  const filtered = (wettkampfer || [])
    .filter(w => {
      const name = `${w.vorname} ${w.nachname}`.toLowerCase();
      return query.trim().length > 0 && name.includes(query.toLowerCase());
    })
    .slice(0, 10);

  const select = (w) => {
    const name = `${w.vorname} ${w.nachname}`;
    setQuery(name);
    onChange(name);
    onFighterSelected?.(w);
    setOpen(false);
    if (nextInputId) {
      // Nächstes Feld (Team-Modus): nach kurzem Tick damit React den State abgearbeitet hat
      setTimeout(() => document.getElementById(nextInputId)?.focus(), 10);
    } else {
      // Kein nächstes Feld: Fokus bleibt im selben Input
      inputRef.current?.focus();
    }
  };

  return (
    <div style={{ position: 'relative', flex: 1 }}>
      <input
        ref={inputRef}
        id={inputId}
        className="team-modal-input"
        value={query}
        onChange={e => { setQuery(e.target.value); onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div className="person-search-dropdown">
          {filtered.map(w => (
            <div
              key={w.wettkaempfer_id}
              className="person-search-item"
              onMouseDown={e => { e.preventDefault(); select(w); }}
            >
              <span className="person-search-name">{w.vorname} {w.nachname}</span>
              {w.geburtsdatum && (
                <span className="person-search-meta">
                  {new Date().getFullYear() - new Date(w.geburtsdatum).getFullYear()} J
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Team-Modal Komponente ────────────────────────────────────────────────────
function TeamModal({ divisionName, mode, initialData, onConfirm, onCancel, wettkampfer }) {
  const isDuo  = mode === 'duo';
  const [teamName,  setTeamName]  = useState(initialData?.teamName  || '');
  const [mitglieder, setMitglieder] = useState(() => {
    if (isDuo) return [(initialData?.mitglieder?.[0] || '')];
    return initialData?.mitglieder?.length ? initialData.mitglieder : ['', ''];
  });
  // Fighter-Objekte parallel zu mitglieder (null wenn manuell eingetippt)
  const [fighters, setFighters] = useState(() => Array(isDuo ? 1 : 2).fill(null));

  const addPerson = () => {
    setMitglieder(prev => [...prev, '']);
    setFighters(prev => [...prev, null]);
  };
  const removePerson = (i) => {
    setMitglieder(prev => prev.filter((_, idx) => idx !== i));
    setFighters(prev => prev.filter((_, idx) => idx !== i));
  };
  const updatePerson = (i, val) => {
    setMitglieder(prev => prev.map((v, idx) => idx === i ? val : v));
    // Wenn manuell geändert → Fighter-Objekt zurücksetzen
    if (!val.trim()) setFighters(prev => { const a = [...prev]; a[i] = null; return a; });
  };
  const updateFighter = (i, fighter) => setFighters(prev => { const a = [...prev]; a[i] = fighter; return a; });

  const handleConfirm = () => {
    if (!teamName.trim()) { alert('Bitte Teamnamen eingeben.'); return; }
    const filled = mitglieder.filter(m => m.trim());
    if (isDuo && filled.length < 1) { alert('Bitte den Namen der 2. Person eingeben.'); return; }
    onConfirm(teamName.trim(), mitglieder.map(m => m.trim()).filter(Boolean), fighters);
  };

  return (
    <div className="team-modal-overlay" onClick={onCancel}>
      <div className="team-modal" onClick={e => e.stopPropagation()}>
        <div className="team-modal-header">
          <h3>{isDuo ? '👥 Duo-Anmeldung' : '👥 Team-Anmeldung'}</h3>
          <span className="team-modal-div">{divisionName}</span>
        </div>

        <div className="team-modal-body">
          <label className="team-modal-label">
            Teamname <span style={{color:'#f87171'}}>*</span>
            <input
              className="team-modal-input"
              value={teamName}
              onChange={e => setTeamName(e.target.value)}
              placeholder={isDuo ? 'z.B. Müller / Schmidt' : 'z.B. Dragons Team A'}
              autoFocus
            />
          </label>

          <div className="team-modal-members">
            <div className="team-modal-members-title">
              {isDuo ? '2. Person' : 'Teammitglieder (weitere Personen)'}
            </div>

            {mitglieder.map((m, i) => (
              <div key={i} className="team-modal-member-row">
                <span className="team-modal-member-nr">{i + 2}.</span>
                <PersonSearchInput
                  value={m}
                  onChange={val => updatePerson(i, val)}
                  onFighterSelected={fighter => updateFighter(i, fighter)}
                  wettkampfer={wettkampfer}
                  placeholder={`Name Person ${i + 2} suchen…`}
                />
                {fighters[i] && (
                  <span className="team-modal-auto-badge" title="Wird automatisch mit-angemeldet">✓ auto</span>
                )}
                {!isDuo && mitglieder.length > 1 && (
                  <button className="team-modal-remove" onClick={() => removePerson(i)} title="Entfernen">✕</button>
                )}
              </div>
            ))}

            {!isDuo && (
              <button className="team-modal-add" onClick={addPerson}>
                + Weitere Person hinzufügen
              </button>
            )}
          </div>

          {fighters.some(f => f) && (
            <div className="team-modal-auto-info">
              Ausgewählte Personen werden automatisch zur Anmeldung hinzugefügt.
            </div>
          )}
        </div>

        <div className="team-modal-footer">
          <button className="team-modal-cancel" onClick={onCancel}>Abbrechen</button>
          <button className="team-modal-confirm" onClick={handleConfirm}>Bestätigen ✓</button>
        </div>
      </div>
    </div>
  );
}

export default WettkampferAuswahlModal;